

/*import React, { useState, useEffect } from 'react';
import mainImage from './logo.jpeg';
import mainLogo from './main.jpeg';
const App = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const products = [
        {
            name: "Premium Breeders Unit",
            icon: "🐷",
            price: "₹3,20,000",
            unit: "10 Females + 1 Male",
            features: ["Elite genetics", "Disease-resistant", "High fertility rate", "Vaccinated stock"],
            bgGradient: "from-amber-600 to-orange-600",
            badge: "Best Seller"
        },
        {
            name: "Quality Piglets",
            icon: "🐖",
            price: "Best Price",
            unit: "Per Piglet (6-8 weeks)",
            features: ["Landrace & Large White", "Vaccinated", "Fast growth", "Farm ready"],
            bgGradient: "from-green-600 to-emerald-600",
            badge: "High Demand"
        },
        {
            name: "Fresh Pork Meat",
            icon: "🥩",
            price: "₹500/kg",
            unit: "Hygienically Processed",
            features: ["Farm fresh daily", "Custom cuts", "Vacuum packed", "Delivery available"],
            bgGradient: "from-red-600 to-rose-600",
            badge: "Premium"
        },
        {
            name: "Frozen Pork Meat",
            icon: "❄️",
            price: "₹550/kg",
            unit: "IQF Frozen",
            features: ["-18°C preserved", "6 months shelf life", "Ready to cook", "Bulk discounts"],
            bgGradient: "from-blue-600 to-cyan-600",
            badge: "Export Quality"
        },
        {
            name: "Live Weight Pork",
            icon: "⚖️",
            price: "₹220/kg",
            unit: "On-site purchase",
            features: ["Transparent weighing", "No hidden charges", "Bulk booking", "Transport support"],
            bgGradient: "from-purple-600 to-indigo-600",
            badge: "Economical"
        }
    ];

    const stats = [
        { value: "5000+", label: "Happy Customers", icon: "👥" },
        { value: "15+", label: "Years of Excellence", icon: "🏆" },
        { value: "100%", label: "ISO Certified", icon: "✅" },
        { value: "50+", label: "Breeder Units Sold", icon: "📈" }
    ];

    const testimonials = [
        {
            name: "Rajesh Kumar",
            role: "Hotel Owner, Hyderabad",
            content: "The quality of pork from Shree Niwas is exceptional. Consistent supply and premium cuts have boosted our restaurant's reputation.",
            rating: 5
        },
        {
            name: "Priya Singh",
            role: "Farm Manager, Maharashtra",
            content: "Purchased their breeder unit - outstanding genetics and health. Our piglet survival rate increased by 40%.",
            rating: 5
        },
        {
            name: "Amit Patel",
            role: "Meat Distributor, Gujarat",
            content: "Best frozen pork quality in India. The packaging and cold chain logistics are world-class.",
            rating: 5
        }
    ];

    const handleWhatsApp = (message) => {
        window.open(`https://wa.me/919876543210?text=${encodeURIComponent(message)}`, '_blank');
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            {/!* Navigation *!/}
            <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg py-3' : 'bg-white/90 backdrop-blur-md py-5'}`}>
                <div className="container mx-auto px-4 md:px-8">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center space-x-3">
                            <div className="bg-white p-1 rounded-full shadow-md flex items-center justify-center">
                                <img
                                    src={mainLogo}
                                    alt="Logo"
                                    className="w-12 h-12 object-contain rounded-full"
                                />
                            </div>
                            <div>
                                <h1 className="font-bold text-xl md:text-2xl tracking-tight">
                                    <span className="text-green-800">SHREE NIWAS</span>
                                    <span className="text-amber-600"> PIGGERY</span>
                                </h1>
                                <p className="text-xs text-gray-500 hidden md:block">ISO 9001:2015 Certified | Est. 2012</p>
                            </div>
                        </div>

                        {/!* Desktop Menu *!/}
                        <div className="hidden md:flex items-center space-x-8">
                            <a href="#home" className="text-gray-700 hover:text-green-700 transition font-medium">Home</a>
                            <a href="#products" className="text-gray-700 hover:text-green-700 transition font-medium">Products</a>
                            <a href="#pricing" className="text-gray-700 hover:text-green-700 transition font-medium">Pricing</a>
                            <a href="#testimonials" className="text-gray-700 hover:text-green-700 transition font-medium">Testimonials</a>
                            <a href="#location" className="text-gray-700 hover:text-green-700 transition font-medium">Location</a>
                            <button
                                onClick={() => handleWhatsApp("Hello! I'm interested in your piggery products. Please share details.")}
                                className="bg-gradient-to-r from-green-600 to-green-700 text-white px-6 py-2 rounded-full font-semibold hover:shadow-lg transition-all flex items-center gap-2"
                            >
                                <span>📞</span> Contact Us
                            </button>
                        </div>

                        {/!* Mobile Menu Button *!/}
                        <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden p-2 text-2xl">
                            {isMenuOpen ? "✕" : "☰"}
                        </button>
                    </div>

                    {/!* Mobile Menu *!/}
                    {isMenuOpen && (
                        <div className="md:hidden mt-4 pb-4 space-y-3">
                            <a href="#home" className="block text-gray-700 hover:text-green-700 py-2" onClick={() => setIsMenuOpen(false)}>Home</a>
                            <a href="#products" className="block text-gray-700 hover:text-green-700 py-2" onClick={() => setIsMenuOpen(false)}>Products</a>
                            <a href="#pricing" className="block text-gray-700 hover:text-green-700 py-2" onClick={() => setIsMenuOpen(false)}>Pricing</a>
                            <a href="#testimonials" className="block text-gray-700 hover:text-green-700 py-2" onClick={() => setIsMenuOpen(false)}>Testimonials</a>
                            <a href="#location" className="block text-gray-700 hover:text-green-700 py-2" onClick={() => setIsMenuOpen(false)}>Location</a>
                            <button
                                onClick={() => {
                                    handleWhatsApp("Hello! I'm interested in your piggery products.");
                                    setIsMenuOpen(false);
                                }}
                                className="w-full bg-gradient-to-r from-green-600 to-green-700 text-white px-6 py-3 rounded-full font-semibold"
                            >
                                Contact on WhatsApp
                            </button>
                        </div>
                    )}
                </div>
            </nav>

            {/!* Hero Section *!/}
            <section id="home" className="pt-28 md:pt-36 pb-20 px-4 bg-gradient-to-br from-green-50 via-white to-amber-50">
                <div className="container mx-auto">
                    <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
                        <div className="lg:w-1/2 space-y-6">
                            <div className="inline-flex items-center gap-2 bg-green-100 px-4 py-2 rounded-full">
                                <span className="text-amber-500">⭐</span>
                                <span className="text-sm font-semibold text-green-800">India's Most Trusted Piggery Farm</span>
                            </div>
                            <h1 className="text-4xl md:text-6xl font-bold leading-tight">
                                Premium Pork &
                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-700 to-amber-600"> Elite Breeders</span>
                            </h1>
                            <p className="text-lg text-gray-600 leading-relaxed">
                                Experience farm-fresh quality with our ISO-certified piggery. From premium breeders to fresh and frozen pork,
                                we deliver excellence straight from our farm to your table.
                            </p>
                            <div className="flex flex-wrap gap-4">
                                <button
                                    onClick={() => handleWhatsApp("I want to place an order for pork/breeders. Please guide me.")}
                                    className="bg-gradient-to-r from-green-600 to-green-700 text-white px-8 py-3 rounded-full font-semibold hover:shadow-xl transition-all flex items-center gap-2"
                                >
                                    <span>📨</span> Order Now
                                </button>
                                <button className="border-2 border-green-600 text-green-700 px-8 py-3 rounded-full font-semibold hover:bg-green-50 transition-all">
                                    Download Brochure
                                </button>
                            </div>
                            <div className="flex items-center gap-6 pt-4">
                                <div className="flex -space-x-2">
                                    {[1,2,3,4].map((i) => (
                                        <div key={i} className="w-10 h-10 rounded-full bg-gradient-to-r from-green-400 to-green-600 border-2 border-white flex items-center justify-center text-white text-sm font-bold">
                                            {String.fromCharCode(64+i)}
                                        </div>
                                    ))}
                                </div>
                                <div className="text-sm text-gray-600">
                                    <span className="font-bold text-green-700">5000+</span> happy customers
                                </div>
                            </div>
                        </div>
                        <div className="lg:w-1/2 relative">
                            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                                <img
                                    src={mainImage}
                                    alt="Piggery Farm"
                                    className="w-full h-[400px] object-cover"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                            </div>
                            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-4 backdrop-blur-sm">
                                <div className="flex items-center gap-3">
                                    <div className="bg-green-100 p-2 rounded-lg">
                                        <span className="text-2xl">🏆</span>
                                    </div>
                                    <div>
                                        <p className="font-bold text-lg">ISO 9001:2015</p>
                                        <p className="text-xs text-gray-500">Certified Quality</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/!* Stats Section *!/}
            <section className="py-12 bg-gradient-to-r from-green-800 to-green-900 text-white">
                <div className="container mx-auto px-4">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                        {stats.map((stat, idx) => (
                            <div key={idx} className="text-center space-y-2">
                                <div className="flex justify-center text-4xl">{stat.icon}</div>
                                <div className="text-3xl md:text-4xl font-bold">{stat.value}</div>
                                <div className="text-sm text-green-200">{stat.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/!* Products Section *!/}
            <section id="products" className="py-20 px-4">
                <div className="container mx-auto">
                    <div className="text-center mb-12">
                        <span className="text-green-700 font-semibold tracking-wide uppercase">Our Premium Range</span>
                        <h2 className="text-4xl md:text-5xl font-bold mt-2 mb-4">Quality Products, <span className="text-green-700">Guaranteed</span></h2>
                        <div className="w-24 h-1 bg-gradient-to-r from-green-600 to-amber-500 mx-auto rounded-full"></div>
                    </div>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {products.map((product, idx) => (
                            <div key={idx} className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden">
                                <div className={`absolute top-4 right-4 bg-gradient-to-r ${product.bgGradient} text-white px-3 py-1 rounded-full text-xs font-bold z-10`}>
                                    {product.badge}
                                </div>
                                <div className={`bg-gradient-to-r ${product.bgGradient} p-6 text-white`}>
                                    <div className="text-5xl mb-4">{product.icon}</div>
                                    <h3 className="text-2xl font-bold">{product.name}</h3>
                                    <p className="text-sm opacity-90 mt-1">{product.unit}</p>
                                </div>
                                <div className="p-6">
                                    <div className="mb-4">
                                        <span className="text-3xl font-bold text-gray-800">{product.price}</span>
                                    </div>
                                    <ul className="space-y-2 mb-6">
                                        {product.features.map((feature, fIdx) => (
                                            <li key={fIdx} className="flex items-center gap-2 text-sm text-gray-600">
                                                <span className="text-green-600">✓</span>
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>
                                    <button
                                        onClick={() => handleWhatsApp(`I'm interested in ${product.name} (${product.price}). Please share more details.`)}
                                        className="w-full bg-gray-100 text-gray-800 py-2 rounded-lg font-semibold hover:bg-green-600 hover:text-white transition-all"
                                    >
                                        Enquire Now
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/!* Pricing Table Section *!/}
            <section id="pricing" className="py-20 px-4 bg-gradient-to-br from-gray-100 to-gray-200">
                <div className="container mx-auto">
                    <div className="text-center mb-12">
                        <span className="text-green-700 font-semibold tracking-wide uppercase">Transparent Pricing</span>
                        <h2 className="text-4xl md:text-5xl font-bold mt-2">Best Rates <span className="text-green-700">Direct from Farm</span></h2>
                    </div>
                    <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead className="bg-gradient-to-r from-green-800 to-green-900 text-white">
                                <tr>
                                    <th className="px-6 py-4 text-left">Product</th>
                                    <th className="px-6 py-4 text-left">Specification</th>
                                    <th className="px-6 py-4 text-left">Price (INR)</th>
                                    <th className="px-6 py-4 text-left">Action</th>
                                </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                {[
                                    { name: "🐖 Live Weight Pork", spec: "Per KG", price: "₹220", color: "text-purple-700" },
                                    { name: "🥩 Fresh Pork Meat", spec: "Per KG (Boneless)", price: "₹500", color: "text-red-600" },
                                    { name: "❄️ Frozen Pork Meat", spec: "Per KG (Vacuum Pack)", price: "₹550", color: "text-blue-600" },
                                    { name: "👑 Breeders Unit", spec: "10 Females + 1 Male", price: "₹3,20,000", color: "text-amber-700" },
                                    { name: "🐗 Piglets", spec: "6-8 weeks old", price: "Best Offer", color: "text-green-700" }
                                ].map((item, idx) => (
                                    <tr key={idx} className="hover:bg-gray-50 transition">
                                        <td className="px-6 py-4 font-semibold">{item.name}</td>
                                        <td className="px-6 py-4 text-gray-600">{item.spec}</td>
                                        <td className={`px-6 py-4 font-bold text-lg ${item.color}`}>{item.price}</td>
                                        <td className="px-6 py-4">
                                            <button
                                                onClick={() => handleWhatsApp(`I want to order ${item.name} (${item.price}). Please share availability.`)}
                                                className="text-green-700 font-semibold hover:text-green-900"
                                            >
                                                Order →
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="p-4 text-center text-sm text-gray-500 bg-gray-50">
                            * GST applicable as per govt norms | Bulk orders get special discounts
                        </div>
                    </div>
                </div>
            </section>

            {/!* Testimonials *!/}
            <section id="testimonials" className="py-20 px-4 bg-white">
                <div className="container mx-auto">
                    <div className="text-center mb-12">
                        <span className="text-green-700 font-semibold tracking-wide uppercase">Testimonials</span>
                        <h2 className="text-4xl md:text-5xl font-bold mt-2">What Our <span className="text-green-700">Customers Say</span></h2>
                    </div>
                    <div className="grid md:grid-cols-3 gap-8">
                        {testimonials.map((testimonial, idx) => (
                            <div key={idx} className="bg-gray-50 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all">
                                <div className="flex mb-4">
                                    {[...Array(testimonial.rating)].map((_, i) => (
                                        <span key={i} className="text-amber-400 text-xl">★</span>
                                    ))}
                                </div>
                                <p className="text-gray-600 italic mb-4">"{testimonial.content}"</p>
                                <div className="border-t pt-4">
                                    <p className="font-bold text-gray-800">{testimonial.name}</p>
                                    <p className="text-sm text-gray-500">{testimonial.role}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/!* Location Map *!/}
            <section id="location" className="py-20 px-4 bg-gradient-to-br from-green-50 to-amber-50">
                <div className="container mx-auto">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl md:text-5xl font-bold">📍 Visit Our <span className="text-green-700">Farm Location</span></h2>
                        <p className="text-gray-600 mt-2">Shree Niwas Piggery Farms LLP, Andhra Pradesh, India</p>
                    </div>
                    <div className="max-w-5xl mx-auto rounded-2xl overflow-hidden shadow-2xl">
                        <iframe
                            src="https://www.openstreetmap.org/export/embed.html?bbox=80.6180%2C16.4762%2C80.6780%2C16.5362&layer=mapnik&marker=16.5062%2C80.6480"
                            className="w-full h-[450px] border-0"
                            title="Farm Location"
                            allowFullScreen
                        ></iframe>
                    </div>
                    <div className="flex flex-wrap justify-center gap-6 mt-8 text-center">
                        <div className="flex items-center gap-2 bg-white px-6 py-3 rounded-full shadow">
                            <span className="text-red-500">📍</span>
                            <span>NH-16, Guntur District, AP</span>
                        </div>
                        <div className="flex items-center gap-2 bg-white px-6 py-3 rounded-full shadow">
                            <span className="text-blue-500">🕐</span>
                            <span>Mon-Sat: 9 AM - 6 PM</span>
                        </div>
                        <div className="flex items-center gap-2 bg-white px-6 py-3 rounded-full shadow">
                            <span className="text-green-600">🚚</span>
                            <span>All India Delivery</span>
                        </div>
                    </div>
                </div>
            </section>

            {/!* Contact Section *!/}
            <section className="py-20 px-4 bg-gradient-to-r from-green-900 to-green-800 text-white">
                <div className="container mx-auto text-center">
                    <h2 className="text-4xl md:text-5xl font-bold mb-4">Ready to Order?</h2>
                    <p className="text-xl text-green-200 mb-8">Connect with us on WhatsApp for instant responses</p>
                    <button
                        onClick={() => handleWhatsApp("Hello! I want to place an order or get more information about your products.")}
                        className="bg-gradient-to-r from-green-500 to-green-600 text-white px-12 py-4 rounded-full text-xl font-bold hover:shadow-2xl transition-all flex items-center gap-3 mx-auto"
                    >
                        <span>📞</span> Chat on WhatsApp
                    </button>
                    <div className="grid md:grid-cols-3 gap-6 max-w-3xl mx-auto mt-12 pt-8 border-t border-green-700">
                        <div>
                            <span className="text-2xl block mb-2">📞</span>
                            <p className="font-semibold">+91 98765 43210</p>
                            <p className="text-sm text-green-300">Call / WhatsApp</p>
                        </div>
                        <div>
                            <span className="text-2xl block mb-2">✉️</span>
                            <p className="font-semibold">sales@shreeniwaspiggery.com</p>
                            <p className="text-sm text-green-300">24/7 Support</p>
                        </div>
                        <div>
                            <span className="text-2xl block mb-2">✅</span>
                            <p className="font-semibold">GST: 37ACMFA6714B1ZK</p>
                            <p className="text-sm text-green-300">ISO 9001:2015</p>
                        </div>
                    </div>
                </div>
            </section>

            {/!* Footer *!/}
            <footer className="bg-gray-900 text-gray-400 py-12 px-4">
                <div className="container mx-auto">
                    <div className="grid md:grid-cols-4 gap-8">
                        <div>
                            <div className="flex items-center gap-2 mb-4">
                                <span className="text-2xl">🐷</span>
                                <span className="font-bold text-white text-lg">SHREE NIWAS PIGGERY</span>
                            </div>
                            <p className="text-sm">Premium piggery farm offering quality breeders, piglets, and pork meat across India.</p>
                        </div>
                        <div>
                            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
                            <ul className="space-y-2 text-sm">
                                <li><a href="#home" className="hover:text-green-400 transition">Home</a></li>
                                <li><a href="#products" className="hover:text-green-400 transition">Products</a></li>
                                <li><a href="#pricing" className="hover:text-green-400 transition">Pricing</a></li>
                                <li><a href="#location" className="hover:text-green-400 transition">Location</a></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="text-white font-semibold mb-4">Certifications</h4>
                            <ul className="space-y-2 text-sm">
                                <li>✓ ISO 9001:2015</li>
                                <li>✓ FSSAI Approved</li>
                                <li>✓ Animal Welfare Certified</li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="text-white font-semibold mb-4">Business Hours</h4>
                            <ul className="space-y-2 text-sm">
                                <li>Monday - Saturday: 9AM - 6PM</li>
                                <li>Sunday: By Appointment</li>
                                <li>Emergency: 24/7 Support</li>
                            </ul>
                        </div>
                    </div>
                    <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
                        <p>© 2026 SHREE NIWAS PIGGERY FARMS LLP | All Rights Reserved | TM Registered</p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default App;*/

import React, { useState, useEffect } from 'react';
import mainImage from './logo.jpeg';
import mainLogo from './main.jpeg';

const App = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const products = [
        {
            name: "Premium Breeders Unit",
            icon: "🐷",
            price: "₹3,20,000",
            unit: "10 Females + 1 Male",
            features: ["Elite genetics", "Disease-resistant", "High fertility rate", "Vaccinated stock"],
            bgGradient: "from-amber-600 to-orange-600",
            badge: "Best Seller"
        },
        {
            name: "Quality Piglets",
            icon: "🐖",
            price: "Best Price",
            unit: "Per Piglet (6-8 weeks)",
            features: ["Landrace & Large White", "Vaccinated", "Fast growth", "Farm ready"],
            bgGradient: "from-green-600 to-emerald-600",
            badge: "High Demand"
        },
        {
            name: "Fresh Pork Meat",
            icon: "🥩",
            price: "₹500/kg",
            unit: "Hygienically Processed",
            features: ["Farm fresh daily", "Custom cuts", "Vacuum packed", "Delivery available"],
            bgGradient: "from-red-600 to-rose-600",
            badge: "Premium"
        },
        {
            name: "Frozen Pork Meat",
            icon: "❄️",
            price: "₹550/kg",
            unit: "IQF Frozen",
            features: ["-18°C preserved", "6 months shelf life", "Ready to cook", "Bulk discounts"],
            bgGradient: "from-blue-600 to-cyan-600",
            badge: "Export Quality"
        },
        {
            name: "Live Weight Pork",
            icon: "⚖️",
            price: "₹220/kg",
            unit: "On-site purchase",
            features: ["Transparent weighing", "No hidden charges", "Bulk booking", "Transport support"],
            bgGradient: "from-purple-600 to-indigo-600",
            badge: "Economical"
        }
    ];

    const stats = [
        { value: "2000+", label: "Happy Customers", icon: "👥" },
        { value: "8+", label: "Years of Excellence", icon: "🏆" },
        { value: "100%", label: "ISO Certified", icon: "✅" },
        { value: "50+", label: "Breeder Units Sold", icon: "📈" }
    ];

    const testimonials = [
        {
            name: "Rajesh Kumar",
            role: "Hotel Owner, Hyderabad",
            content: "The quality of pork from Shree Niwas is exceptional. Consistent supply and premium cuts have boosted our restaurant's reputation.",
            rating: 5
        },
        {
            name: "Priya Singh",
            role: "Farm Manager, Maharashtra",
            content: "Purchased their breeder unit - outstanding genetics and health. Our piglet survival rate increased by 40%.",
            rating: 5
        },
        {
            name: "Amit Patel",
            role: "Meat Distributor, Gujarat",
            content: "Best frozen pork quality in India. The packaging and cold chain logistics are world-class.",
            rating: 5
        }
    ];

    // Updated WhatsApp number
    const whatsappNumber = "919502434446";

    const handleWhatsApp = (message) => {
        window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, '_blank');
    };

    // Google Maps embed URL (you can replace the src with your actual Google Maps embed link)
    //const googleMapsEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30450.456789123!2d80.6180!3d16.5062!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35f1f1f1f1f1f1%3A0x1234567890abcdef!2sGuntur%2C%20Andhra%20Pradesh!5e0!3m2!1sen!2sin!4v1234567890!5m2!1sen!2sin";

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            {/* Navigation */}
            <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg py-3' : 'bg-white/90 backdrop-blur-md py-5'}`}>
                <div className="container mx-auto px-4 md:px-8">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center space-x-3">
                            <div className="bg-white p-1 rounded-full shadow-md flex items-center justify-center">
                                <img
                                    src={mainLogo}
                                    alt="Logo"
                                    className="w-12 h-12 object-contain rounded-full"
                                />
                            </div>
                            <div>
                                <h1 className="font-bold text-xl md:text-2xl tracking-tight">
                                    <span className="text-green-800">ARIGHNI</span>
                                    <span className="text-amber-600"> PIGGERY</span>
                                </h1>
                                <p className="text-xs text-gray-500 hidden md:block">ISO 9001:2015 Certified | Est. 2012</p>
                            </div>
                        </div>

                        {/* Desktop Menu */}
                        <div className="hidden md:flex items-center space-x-8">
                            <a href="#home" className="text-gray-700 hover:text-green-700 transition font-medium">Home</a>
                            <a href="#products" className="text-gray-700 hover:text-green-700 transition font-medium">Products</a>
                            <a href="#pricing" className="text-gray-700 hover:text-green-700 transition font-medium">Pricing</a>
                            <a href="#testimonials" className="text-gray-700 hover:text-green-700 transition font-medium">Testimonials</a>
                            <a href="#location" className="text-gray-700 hover:text-green-700 transition font-medium">Location</a>
                            <button
                                onClick={() => handleWhatsApp("Hello! I'm interested in your piggery products. Please share details.")}
                                className="bg-gradient-to-r from-green-600 to-green-700 text-white px-6 py-2 rounded-full font-semibold hover:shadow-lg transition-all flex items-center gap-2"
                            >
                                <span>📞</span> Contact Us
                            </button>
                        </div>

                        {/* Mobile Menu Button */}
                        <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden p-2 text-2xl">
                            {isMenuOpen ? "✕" : "☰"}
                        </button>
                    </div>

                    {/* Mobile Menu */}
                    {isMenuOpen && (
                        <div className="md:hidden mt-4 pb-4 space-y-3">
                            <a href="#home" className="block text-gray-700 hover:text-green-700 py-2" onClick={() => setIsMenuOpen(false)}>Home</a>
                            <a href="#products" className="block text-gray-700 hover:text-green-700 py-2" onClick={() => setIsMenuOpen(false)}>Products</a>
                            <a href="#pricing" className="block text-gray-700 hover:text-green-700 py-2" onClick={() => setIsMenuOpen(false)}>Pricing</a>
                            <a href="#testimonials" className="block text-gray-700 hover:text-green-700 py-2" onClick={() => setIsMenuOpen(false)}>Testimonials</a>
                            <a href="#location" className="block text-gray-700 hover:text-green-700 py-2" onClick={() => setIsMenuOpen(false)}>Location</a>
                            <button
                                onClick={() => {
                                    handleWhatsApp("Hello! I'm interested in your piggery products.");
                                    setIsMenuOpen(false);
                                }}
                                className="w-full bg-gradient-to-r from-green-600 to-green-700 text-white px-6 py-3 rounded-full font-semibold"
                            >
                                Contact on WhatsApp
                            </button>
                        </div>
                    )}
                </div>
            </nav>

            {/* Hero Section */}
            <section id="home" className="pt-28 md:pt-36 pb-20 px-4 bg-gradient-to-br from-green-50 via-white to-amber-50">
                <div className="container mx-auto">
                    <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
                        <div className="lg:w-1/2 space-y-6">
                            <div className="inline-flex items-center gap-2 bg-green-100 px-4 py-2 rounded-full">
                                <span className="text-amber-500">⭐</span>
                                <span className="text-sm font-semibold text-green-800">India's Most Trusted Piggery Farm</span>
                            </div>
                            <h1 className="text-4xl md:text-6xl font-bold leading-tight">
                                Premium Pork &
                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-700 to-amber-600"> Elite Breeders</span>
                            </h1>
                            <p className="text-lg text-gray-600 leading-relaxed">
                                Experience farm-fresh quality with our ISO-certified piggery. From premium breeders to fresh and frozen pork,
                                we deliver excellence straight from our farm to your table.
                            </p>
                            <div className="flex flex-wrap gap-4">
                                <button
                                    onClick={() => handleWhatsApp("I want to place an order for pork/breeders. Please guide me.")}
                                    className="bg-gradient-to-r from-green-600 to-green-700 text-white px-8 py-3 rounded-full font-semibold hover:shadow-xl transition-all flex items-center gap-2"
                                >
                                    <span>📨</span> Order Now
                                </button>
                                <button className="border-2 border-green-600 text-green-700 px-8 py-3 rounded-full font-semibold hover:bg-green-50 transition-all">
                                    Download Brochure
                                </button>
                            </div>
                            <div className="flex items-center gap-6 pt-4">
                                <div className="flex -space-x-2">
                                    {[1,2,3,4].map((i) => (
                                        <div key={i} className="w-10 h-10 rounded-full bg-gradient-to-r from-green-400 to-green-600 border-2 border-white flex items-center justify-center text-white text-sm font-bold">
                                            {String.fromCharCode(64+i)}
                                        </div>
                                    ))}
                                </div>
                                <div className="text-sm text-gray-600">
                                    <span className="font-bold text-green-700">2000+</span> happy customers
                                </div>
                            </div>
                        </div>
                        <div className="lg:w-1/2 relative">
                            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                                <img
                                    src={mainImage}
                                    alt="Piggery Farm"
                                    className="w-full h-[400px] object-cover"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                            </div>
                            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-4 backdrop-blur-sm">
                                <div className="flex items-center gap-3">
                                    <div className="bg-green-100 p-2 rounded-lg">
                                        <span className="text-2xl">🏆</span>
                                    </div>
                                    <div>
                                        <p className="font-bold text-lg">ISO 9001:2015</p>
                                        <p className="text-xs text-gray-500">Certified Quality</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Stats Section */}
            <section className="py-12 bg-gradient-to-r from-green-800 to-green-900 text-white">
                <div className="container mx-auto px-4">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                        {stats.map((stat, idx) => (
                            <div key={idx} className="text-center space-y-2">
                                <div className="flex justify-center text-4xl">{stat.icon}</div>
                                <div className="text-3xl md:text-4xl font-bold">{stat.value}</div>
                                <div className="text-sm text-green-200">{stat.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Products Section */}
            <section id="products" className="py-20 px-4">
                <div className="container mx-auto">
                    <div className="text-center mb-12">
                        <span className="text-green-700 font-semibold tracking-wide uppercase">Our Premium Range</span>
                        <h2 className="text-4xl md:text-5xl font-bold mt-2 mb-4">Quality Products, <span className="text-green-700">Guaranteed</span></h2>
                        <div className="w-24 h-1 bg-gradient-to-r from-green-600 to-amber-500 mx-auto rounded-full"></div>
                    </div>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {products.map((product, idx) => (
                            <div key={idx} className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden">
                                <div className={`absolute top-4 right-4 bg-gradient-to-r ${product.bgGradient} text-white px-3 py-1 rounded-full text-xs font-bold z-10`}>
                                    {product.badge}
                                </div>
                                <div className={`bg-gradient-to-r ${product.bgGradient} p-6 text-white`}>
                                    <div className="text-5xl mb-4">{product.icon}</div>
                                    <h3 className="text-2xl font-bold">{product.name}</h3>
                                    <p className="text-sm opacity-90 mt-1">{product.unit}</p>
                                </div>
                                <div className="p-6">
                                    <div className="mb-4">
                                        <span className="text-3xl font-bold text-gray-800">{product.price}</span>
                                    </div>
                                    <ul className="space-y-2 mb-6">
                                        {product.features.map((feature, fIdx) => (
                                            <li key={fIdx} className="flex items-center gap-2 text-sm text-gray-600">
                                                <span className="text-green-600">✓</span>
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>
                                    <button
                                        onClick={() => handleWhatsApp(`I'm interested in ${product.name} (${product.price}). Please share more details.`)}
                                        className="w-full bg-gray-100 text-gray-800 py-2 rounded-lg font-semibold hover:bg-green-600 hover:text-white transition-all"
                                    >
                                        Enquire Now
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Pricing Table Section */}
            <section id="pricing" className="py-20 px-4 bg-gradient-to-br from-gray-100 to-gray-200">
                <div className="container mx-auto">
                    <div className="text-center mb-12">
                        <span className="text-green-700 font-semibold tracking-wide uppercase">Transparent Pricing</span>
                        <h2 className="text-4xl md:text-5xl font-bold mt-2">Best Rates <span className="text-green-700">Direct from Farm</span></h2>
                    </div>
                    <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead className="bg-gradient-to-r from-green-800 to-green-900 text-white">
                                <tr>
                                    <th className="px-6 py-4 text-left">Product</th>
                                    <th className="px-6 py-4 text-left">Specification</th>
                                    <th className="px-6 py-4 text-left">Price (INR)</th>
                                    <th className="px-6 py-4 text-left">Action</th>
                                </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                {[
                                    { name: "🐖 Live Weight Pork", spec: "Per KG", price: "₹220", color: "text-purple-700" },
                                    { name: "🥩 Fresh Pork Meat", spec: "Per KG (Boneless)", price: "₹500", color: "text-red-600" },
                                    { name: "❄️ Frozen Pork Meat", spec: "Per KG (Vacuum Pack)", price: "₹550", color: "text-blue-600" },
                                    { name: "👑 Breeders Unit", spec: "10 Females + 1 Male", price: "₹3,20,000", color: "text-amber-700" },
                                    { name: "🐗 Piglets", spec: "6-8 weeks old", price: "Best Offer", color: "text-green-700" }
                                ].map((item, idx) => (
                                    <tr key={idx} className="hover:bg-gray-50 transition">
                                        <td className="px-6 py-4 font-semibold">{item.name}</td>
                                        <td className="px-6 py-4 text-gray-600">{item.spec}</td>
                                        <td className={`px-6 py-4 font-bold text-lg ${item.color}`}>{item.price}</td>
                                        <td className="px-6 py-4">
                                            <button
                                                onClick={() => handleWhatsApp(`I want to order ${item.name} (${item.price}). Please share availability.`)}
                                                className="text-green-700 font-semibold hover:text-green-900"
                                            >
                                                Order →
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="p-4 text-center text-sm text-gray-500 bg-gray-50">
                            * GST applicable as per govt norms | Bulk orders get special discounts
                        </div>
                    </div>
                </div>
            </section>

            {/* Testimonials */}
            <section id="testimonials" className="py-20 px-4 bg-white">
                <div className="container mx-auto">
                    <div className="text-center mb-12">
                        <span className="text-green-700 font-semibold tracking-wide uppercase">Testimonials</span>
                        <h2 className="text-4xl md:text-5xl font-bold mt-2">What Our <span className="text-green-700">Customers Say</span></h2>
                    </div>
                    <div className="grid md:grid-cols-3 gap-8">
                        {testimonials.map((testimonial, idx) => (
                            <div key={idx} className="bg-gray-50 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all">
                                <div className="flex mb-4">
                                    {[...Array(testimonial.rating)].map((_, i) => (
                                        <span key={i} className="text-amber-400 text-xl">★</span>
                                    ))}
                                </div>
                                <p className="text-gray-600 italic mb-4">"{testimonial.content}"</p>
                                <div className="border-t pt-4">
                                    <p className="font-bold text-gray-800">{testimonial.name}</p>
                                    <p className="text-sm text-gray-500">{testimonial.role}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Location Map Section - Updated with Google Maps */}
            {/* Location Map Section - ARIGHNI PIGGERY FARMS */}
            <section id="location" className="py-20 px-4 bg-gradient-to-br from-green-50 to-amber-50">
                <div className="container mx-auto">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl md:text-5xl font-bold">📍 Visit Our <span className="text-green-700">Farm Location</span></h2>
                        <p className="text-gray-600 mt-2">ARIGHNI PIGGERY FARMS LLP, Thanti Konda, East Godavari, AP</p>
                    </div>

                    {/* Google Maps Embed - Corrected working link */}
                    <div className="max-w-5xl mx-auto rounded-2xl overflow-hidden shadow-2xl">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d60921.123456789!2d81.8031363!3d17.2446363!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a370d8b6a85e169%3A0xb47e3ca503808755!2sARIGHNI%20PIGGERY%20FARMS!5e0!3m2!1sen!2sin!4v1616161616161!5m2!1sen!2sin"
                            className="w-full h-[450px] border-0"
                            title="ARIGHNI PIGGERY FARMS - Google Maps"
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </div>

                    {/* Google Maps Link Button - Using your specific share URL */}
                    <div className="flex justify-center mt-6">
                        <a
                            href="https://www.google.com/maps/place/ARIGHNI+PIGGERY+FARMS/@17.2446363,81.8031363,17z/data=!4m14!1m7!3m6!1s0x3a370d8b6a85e169:0xb47e3ca503808755!2sARIGHNI+PIGGERY+FARMS!8m2!3d17.2446363!4d81.8057112!16s%2Fg%2F11ms97cnz2!3m5!1s0x3a370d8b6a85e169:0xb47e3ca503808755!8m2!3d17.2446363!4d81.8057112!16s%2Fg%2F11ms97cnz2?hl=en-GB&entry=ttu&g_ep=EgoyMDI2MDQwNy4wIKXMDSoASAFQAw%3D%3D"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 bg-red-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-red-700 transition-all shadow-lg"
                        >
                            <span>🗺️</span> Open in Google Maps
                        </a>
                    </div>

                    {/* Location Address Chips - Updated with full address */}
                    <div className="flex flex-wrap justify-center gap-6 mt-8 text-center">
                        <div className="flex items-center gap-2 bg-white px-6 py-3 rounded-full shadow">
                            <span className="text-red-500">📍</span>
                            <span>Ravanaipeta road, Thanti Konda, Gokavaram, AP - 533286</span>
                        </div>
                        <div className="flex items-center gap-2 bg-white px-6 py-3 rounded-full shadow">
                            <span className="text-blue-500">🕐</span>
                            <span>Mon-Sat: 9 AM - 6 PM</span>
                        </div>
                        <div className="flex items-center gap-2 bg-white px-6 py-3 rounded-full shadow">
                            <span className="text-green-600">🚚</span>
                            <span>All India Delivery</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Section - Updated with new WhatsApp number */}
            <section className="py-20 px-4 bg-gradient-to-r from-green-900 to-green-800 text-white">
                <div className="container mx-auto text-center">
                    <h2 className="text-4xl md:text-5xl font-bold mb-4">Ready to Order?</h2>
                    <p className="text-xl text-green-200 mb-8">Connect with us on WhatsApp for instant responses</p>
                    <button
                        onClick={() => handleWhatsApp("Hello! I want to place an order or get more information about your products.")}
                        className="bg-gradient-to-r from-green-500 to-green-600 text-white px-12 py-4 rounded-full text-xl font-bold hover:shadow-2xl transition-all flex items-center gap-3 mx-auto"
                    >
                        <span>📞</span> Chat on WhatsApp
                    </button>
                    <div className="grid md:grid-cols-3 gap-6 max-w-3xl mx-auto mt-12 pt-8 border-t border-green-700">
                        <div>
                            <span className="text-2xl block mb-2">📞</span>
                            <p className="font-semibold">+91 9502434446</p>
                            <p className="text-sm text-green-300">Call / WhatsApp</p>
                        </div>
                        <div>
                            <span className="text-2xl block mb-2">✉️</span>
                            <p className="font-semibold">arighnipiggeryfarmsllp@gmail.com</p>
                            <p className="text-sm text-green-300">24/7 Support</p>
                        </div>
                        <div>
                            <span className="text-2xl block mb-2">✅</span>
                            <p className="font-semibold">GST: 37ACMFA6714B1ZK</p>
                            <p className="text-sm text-green-300">ISO 9001:2015</p>
                        </div>
                        <div>
                            <span className="text-2xl block mb-2">✅</span>
                            <p className="font-semibold">FSSAI: 10126018000038</p>

                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-gray-900 text-gray-400 py-12 px-4">
                <div className="container mx-auto">
                    <div className="grid md:grid-cols-4 gap-8">
                        <div>
                            <div className="flex items-center gap-2 mb-4">
                                {/*<span className="text-2xl">🐷</span>*/}
                                <span className="font-bold text-white text-lg">ARIGHNI PIGGERY</span>
                            </div>
                            <p className="text-sm">Premium piggery farm offering quality breeders, piglets, and pork meat across India.</p>
                        </div>
                        <div>
                            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
                            <ul className="space-y-2 text-sm">
                                <li><a href="#home" className="hover:text-green-400 transition">Home</a></li>
                                <li><a href="#products" className="hover:text-green-400 transition">Products</a></li>
                                <li><a href="#pricing" className="hover:text-green-400 transition">Pricing</a></li>
                                <li><a href="#location" className="hover:text-green-400 transition">Location</a></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="text-white font-semibold mb-4">Certifications</h4>
                            <ul className="space-y-2 text-sm">
                                <li>✓ ISO 9001:2015</li>
                                <li>✓ FSSAI Approved</li>
                                <li>✓ Animal Welfare Certified</li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="text-white font-semibold mb-4">Business Hours</h4>
                            <ul className="space-y-2 text-sm">
                                <li>Monday - Saturday: 9AM - 6PM</li>
                                <li>Sunday: By Appointment</li>
                                <li>Emergency: 24/7 Support</li>
                            </ul>
                        </div>
                    </div>
                    <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
                        <p>© 2026 ARIGHNI PIGGERY FARMS LLP | All Rights Reserved | TM Registered</p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default App;

/*
import { useState, useEffect, useRef, useCallback } from "react";
import mainLogo from './main.jpeg';
/!* ═══════════════════════════════════════════
   CONFIG — edit before going live
═══════════════════════════════════════════ *!/
const C = {
    name:      "ARIGHNI",
    sub:       "Premium Livestock & Pork Specialists",
    tagline:   "From Our Farm to Your Table — Freshness You Can Trust",
    phone:     "+91 98765 43210",
    whatsapp:  "919876543210",
    address:   "Your Shop Name, Street, City, State – PIN",
    hours:     "Mon–Sat  6:00 AM – 8:00 PM   ·   Sun  6:00 AM – 1:00 PM",
    mapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.9!2d80.2707!3d13.0827!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267d7f4a4b7b1%3A0x0!2zMTPCsDA0JzU3LjciTiA4MMKwMTYnMTQuNiJF!5e0!3m2!1sen!2sin!4v1234567890",
    mapsLink:  "https://maps.google.com",
};
const waLink = `https://wa.me/${C.whatsapp}?text=Hi! I would like to enquire about your pork products.`;

const BG    = "#060402";
const CARD  = "#0E0A05";
const CARD2 = "#130D06";
const GOLD  = "#D4940A";
const GOLDB = "#F0B830";
const GOLDP = "#FDE58A";
const AMBER = "#B06C08";
const CREAM = "#F0E5CC";
const MUTED = "#8A7A62";
const BORDER= "rgba(180,130,30,0.13)";
const BRHOT = "rgba(220,160,40,0.5)";
const GREEN = "#28B060";
const GREEND= "#178040";
const WA    = "#25D366";

function useStyles() {
    useEffect(() => {
        if (document.getElementById("pfp-ultra")) return;
        const s = document.createElement("style");
        s.id = "pfp-ultra";
        s.textContent = `
      *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
      html{scroll-behavior:smooth}
      body{background:${BG};overflow-x:hidden;cursor:none}
      ::-webkit-scrollbar{width:3px}
      ::-webkit-scrollbar-track{background:transparent}
      ::-webkit-scrollbar-thumb{background:${AMBER};border-radius:2px}
      @keyframes marquee{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}
      @keyframes floatY{0%,100%{transform:translateY(0) rotate(0deg)}50%{transform:translateY(-16px) rotate(3deg)}}
      @keyframes gradShift{0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}}
      @keyframes waRing{0%,100%{box-shadow:0 0 0 0 rgba(37,211,102,.6)}70%{box-shadow:0 0 0 20px rgba(37,211,102,0)}}
      @keyframes scanline{0%{top:-5%}100%{top:110%}}
      @keyframes borderFlow{0%{background-position:0% 0%}100%{background-position:200% 0%}}
      @keyframes fadeUp{from{opacity:0;transform:translateY(40px)}to{opacity:1;transform:translateY(0)}}
      @keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}
      @keyframes spinR{from{transform:rotate(0)}to{transform:rotate(-360deg)}}
      @keyframes pulse2{0%,100%{opacity:.5;transform:scale(1)}50%{opacity:1;transform:scale(1.04)}}
      @keyframes particleDrift{0%{transform:translateY(0) translateX(0) scale(1);opacity:.8}50%{transform:translateY(-90px) translateX(18px) scale(1.3);opacity:.3}100%{transform:translateY(-180px) translateX(-8px) scale(0.4);opacity:0}}
      @keyframes shimmerSlide{0%{left:-100%}100%{left:200%}}
      @keyframes lineGrow{from{width:0}to{width:100%}}
      @keyframes stampIn{0%{opacity:0;transform:scale(1.8) rotate(-12deg)}60%{transform:scale(.95) rotate(2deg)}100%{opacity:1;transform:scale(1) rotate(0deg)}}
      @keyframes revealClip{from{clip-path:inset(0 100% 0 0)}to{clip-path:inset(0 0% 0 0)}}
      .reveal{opacity:0;transform:translateY(35px);transition:opacity .8s cubic-bezier(.16,1,.3,1),transform .8s cubic-bezier(.16,1,.3,1)}
      .reveal.on{opacity:1;transform:none}
      .revealL{opacity:0;transform:translateX(-40px);transition:opacity .8s cubic-bezier(.16,1,.3,1),transform .8s cubic-bezier(.16,1,.3,1)}
      .revealL.on{opacity:1;transform:none}
      .revealR{opacity:0;transform:translateX(40px);transition:opacity .8s cubic-bezier(.16,1,.3,1),transform .8s cubic-bezier(.16,1,.3,1)}
      .revealR.on{opacity:1;transform:none}
      .nav-a{color:${MUTED};text-decoration:none;font:.78rem/1 'DM Sans',sans-serif;letter-spacing:.1em;font-weight:500;transition:color .2s;position:relative}
      .nav-a::after{content:'';position:absolute;bottom:-4px;left:0;width:0;height:1px;background:${GOLD};transition:width .3s}
      .nav-a:hover{color:${GOLDB}}
      .nav-a:hover::after{width:100%}
      .prod-card{transition:transform .5s cubic-bezier(.16,1,.3,1),box-shadow .5s ease}
      .prod-card:hover{box-shadow:0 50px 100px rgba(0,0,0,.7),0 0 80px rgba(180,130,30,.08)!important}
      .price-wrap{transition:transform .4s cubic-bezier(.16,1,.3,1),box-shadow .4s ease,border-color .4s}
      .price-wrap:hover{transform:translateY(-12px)!important;box-shadow:0 40px 80px rgba(0,0,0,.6)!important}
      .cursor-dot{width:8px;height:8px;background:#fff;border-radius:50%;position:fixed;transform:translate(-50%,-50%);transition:width .15s,height .15s;pointer-events:none;z-index:99999;mix-blend-mode:difference}
      .cursor-ring{width:36px;height:36px;border:1px solid rgba(255,255,255,.4);border-radius:50%;position:fixed;transform:translate(-50%,-50%);transition:all .1s ease;pointer-events:none;z-index:99998;mix-blend-mode:difference}
      .shimmer-btn{position:relative;overflow:hidden}
      .shimmer-btn::after{content:'';position:absolute;top:0;left:-100%;width:55%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.14),transparent);animation:shimmerSlide 2.8s ease-in-out infinite}
      .tag-pill{display:inline-flex;align-items:center;gap:.45rem;padding:.28rem .9rem;border-radius:100px;font:600 .58rem/1 'DM Sans',sans-serif;letter-spacing:.2em;text-transform:uppercase}
    `;
        document.head.appendChild(s);
        const lk = document.createElement("link");
        lk.rel = "stylesheet";
        lk.href = "https://fonts.googleapis.com/css2?family=Cormorant:ital,wght@0,300;0,500;0,700;1,300;1,500;1,700&family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap";
        document.head.appendChild(lk);
    }, []);
}

function useReveal() {
    useEffect(() => {
        const io = new IntersectionObserver(entries =>
                entries.forEach(e => { if (e.isIntersecting) e.target.classList.add("on"); }),
            { threshold: 0.07 }
        );
        document.querySelectorAll(".reveal,.revealL,.revealR").forEach(el => io.observe(el));
        return () => io.disconnect();
    });
}

function CountUp({ end, suffix = "", prefix = "" }) {
    const [v, setV] = useState(0);
    const ref = useRef();
    useEffect(() => {
        const io = new IntersectionObserver(([e]) => {
            if (!e.isIntersecting) return;
            io.disconnect();
            let n = 0; const step = Math.ceil(end / 60);
            const t = setInterval(() => { n = Math.min(n + step, end); setV(n); if (n >= end) clearInterval(t); }, 18);
        }, { threshold: .5 });
        if (ref.current) io.observe(ref.current);
        return () => io.disconnect();
    }, [end]);
    return <span ref={ref}>{prefix}{v}{suffix}</span>;
}

function CustomCursor() {
    const dot  = useRef();
    const ring = useRef();
    useEffect(() => {
        const move = e => {
            if (dot.current)  { dot.current.style.left  = e.clientX+"px"; dot.current.style.top  = e.clientY+"px"; }
            if (ring.current) { ring.current.style.left = e.clientX+"px"; ring.current.style.top = e.clientY+"px"; }
        };
        window.addEventListener("mousemove", move);
        return () => window.removeEventListener("mousemove", move);
    }, []);
    return (<><div ref={dot} className="cursor-dot"/><div ref={ring} className="cursor-ring"/></>);
}

function ParticleField({ count = 24 }) {
    const particles = useRef(Array.from({ length: count }, (_, i) => ({
        id: i, x: Math.random()*100, y: Math.random()*100,
        size: Math.random()*2.5+.8, delay: Math.random()*9, dur: Math.random()*7+6,
    }))).current;
    return (
        <div style={{ position:"absolute", inset:0, overflow:"hidden", pointerEvents:"none" }}>
            {particles.map(p => (
                <div key={p.id} style={{
                    position:"absolute", left:`${p.x}%`, top:`${p.y}%`,
                    width:p.size, height:p.size, borderRadius:"50%", background:GOLD, opacity:0,
                    animation:`particleDrift ${p.dur}s ease-in-out ${p.delay}s infinite`,
                }}/>
            ))}
        </div>
    );
}

function NoiseOverlay({ opacity=0.025 }) {
    return (
        <svg style={{ position:"absolute",inset:0,width:"100%",height:"100%",pointerEvents:"none",opacity }} xmlns="http://www.w3.org/2000/svg">
            <filter id={`n${opacity}`}>
                <feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch"/>
                <feColorMatrix type="saturate" values="0"/>
            </filter>
            <rect width="100%" height="100%" filter={`url(#n${opacity})`}/>
        </svg>
    );
}

function SectionLabel({ children }) {
    return (
        <div style={{ display:"inline-flex", alignItems:"center", gap:".75rem", marginBottom:"1.2rem" }}>
            <div style={{ width:28, height:1, background:GOLD }}/>
            <span style={{ fontSize:".6rem", letterSpacing:".35em", color:GOLD, fontWeight:600, fontFamily:"'DM Sans',sans-serif", textTransform:"uppercase" }}>{children}</span>
            <div style={{ width:28, height:1, background:GOLD }}/>
        </div>
    );
}

function Divider() {
    return (
        <div style={{ display:"flex", alignItems:"center", gap:"1rem", margin:"1.2rem 0" }}>
            <div style={{ flex:1, height:"1px", background:`linear-gradient(90deg, transparent, ${BORDER})` }}/>
            <div style={{ width:6, height:6, borderRadius:"50%", background:GOLD, boxShadow:`0 0 12px ${GOLD}` }}/>
            <div style={{ flex:1, height:"1px", background:`linear-gradient(90deg, ${BORDER}, transparent)` }}/>
        </div>
    );
}

function TiltCard({ children, style, className }) {
    const ref = useRef();
    const handleMove = useCallback(e => {
        const el = ref.current; if (!el) return;
        const { left, top, width, height } = el.getBoundingClientRect();
        const x = (e.clientX - left)/width - .5;
        const y = (e.clientY - top)/height - .5;
        el.style.transform = `perspective(900px) rotateY(${x*14}deg) rotateX(${-y*14}deg) scale(1.025)`;
    }, []);
    const handleLeave = useCallback(() => {
        if (ref.current) ref.current.style.transform = "perspective(900px) rotateY(0deg) rotateX(0deg) scale(1)";
    }, []);
    return (
        <div ref={ref} className={className} style={{ ...style, transition:"transform .6s cubic-bezier(.16,1,.3,1)", transformStyle:"preserve-3d" }}
             onMouseMove={handleMove} onMouseLeave={handleLeave}>
            {children}
        </div>
    );
}

/!* ── NAVBAR ── *!/
function Navbar() {
    const [sc, setSc] = useState(false);
    useEffect(() => {
        const fn = () => setSc(window.scrollY > 60);
        window.addEventListener("scroll", fn);
        return () => window.removeEventListener("scroll", fn);
    }, []);
    return (
        <nav style={{
            position:"fixed",top:0,left:0,right:0,zIndex:900,
            display:"flex",justifyContent:"space-between",alignItems:"center",
            padding:sc?".8rem 3rem":"1.6rem 3rem",
            background:sc?"rgba(6,4,2,.96)":"transparent",
            backdropFilter:sc?"blur(30px) saturate(180%)":"none",
            borderBottom:sc?`1px solid ${BORDER}`:"none",
            transition:"all .5s cubic-bezier(.16,1,.3,1)",
        }}>
            <div style={{ display:"flex", alignItems:"center", gap:".9rem" }}>
                <div
                    style={{
                        width: 42,
                        height: 42,
                        background: `conic-gradient(from 0deg, ${AMBER}, ${GOLD}, ${GOLDB}, ${AMBER})`,
                        borderRadius: "50%",
                        padding: 1.5,
                        animation: "spin 12s linear infinite"
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            background: BG,
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <img
                            src={mainLogo}
                            alt="logo"
                            style={{
                                width: "70%",
                                height: "70%",
                                objectFit: "contain",
                                borderRadius: "50%"
                            }}
                        />
                    </div>
                </div>
                <div>
                    <div style={{ fontFamily:"'Cormorant',serif",fontWeight:700,fontSize:"1.05rem",color:GOLDB,letterSpacing:".1em" }}>{C.name}</div>
                    <div style={{ fontSize:".5rem",color:MUTED,letterSpacing:".22em",fontFamily:"'DM Mono',monospace" }}>PREMIUM · LIVESTOCK · SPECIALISTS</div>
                </div>
            </div>
            <div style={{ display:"flex",gap:"2.5rem",alignItems:"center" }}>
                {["Products","Pricing","Why Us","Location","Contact"].map(s => (
                    <a key={s} href={`#${s.toLowerCase().replace(/ /g,"-")}`} className="nav-a">{s}</a>
                ))}
            </div>
            <a href={waLink} target="_blank" rel="noreferrer" className="shimmer-btn" style={{
                background:`linear-gradient(135deg,${GREEN},${GREEND})`, color:"#fff",
                padding:".55rem 1.5rem", borderRadius:100, fontSize:".76rem",fontWeight:600,
                textDecoration:"none",fontFamily:"'DM Sans',sans-serif",letterSpacing:".04em",
                boxShadow:"0 4px 20px rgba(37,211,102,.3)", border:`1px solid rgba(37,211,102,.3)`,
            }}>WhatsApp ↗</a>
        </nav>
    );
}

/!* ── HERO ── *!/
function Hero() {
    const [mousePos, setMousePos] = useState({ x:0, y:0 });
    useEffect(() => {
        const fn = e => setMousePos({ x:e.clientX/window.innerWidth-.5, y:e.clientY/window.innerHeight-.5 });
        window.addEventListener("mousemove", fn);
        return () => window.removeEventListener("mousemove", fn);
    }, []);
    return (
        <section style={{ minHeight:"100vh", position:"relative", overflow:"hidden", display:"flex", alignItems:"center" }}>
            <div style={{ position:"absolute",inset:0, background:`radial-gradient(ellipse 90% 70% at 60% 40%, rgba(160,90,15,.15) 0%, transparent 65%)` }}/>
            <div style={{ position:"absolute",inset:0, background:`radial-gradient(ellipse 50% 60% at 10% 80%, rgba(100,50,5,.1) 0%, transparent 60%)` }}/>
            <div style={{ position:"absolute",inset:0,overflow:"hidden",pointerEvents:"none" }}>
                <div style={{ position:"absolute",top:0,right:0,width:"50%",height:"100%", display:"grid", gridTemplateColumns:"repeat(auto-fill,44px)", gap:3, opacity:.04 }}>
                    {Array.from({ length:200 }).map((_,i)=>(
                        <div key={i} style={{ width:44,height:50, background:GOLD, clipPath:"polygon(50% 0%,100% 25%,100% 75%,50% 100%,0% 75%,0% 25%)" }}/>
                    ))}
                </div>
            </div>
            <div style={{ position:"absolute",width:700,height:700,borderRadius:"50%", background:"radial-gradient(circle, rgba(180,120,20,.08) 0%, transparent 65%)", top:"50%",left:"55%", transform:`translate(calc(-50% + ${mousePos.x*30}px), calc(-50% + ${mousePos.y*30}px))`, transition:"transform .8s cubic-bezier(.16,1,.3,1)",pointerEvents:"none" }}/>
            <div style={{ position:"absolute",width:400,height:400,borderRadius:"50%", background:"radial-gradient(circle, rgba(140,80,10,.07) 0%, transparent 65%)", top:"20%",left:"15%", transform:`translate(${mousePos.x*-20}px, ${mousePos.y*-20}px)`, transition:"transform .6s cubic-bezier(.16,1,.3,1)",pointerEvents:"none" }}/>
            {[900,680,480,320].map((sz,i) => (
                <div key={sz} style={{ position:"absolute",width:sz,height:sz,borderRadius:"50%", border:`1px solid rgba(180,130,30,${.03+i*.02})`, top:"50%",left:"58%", transform:"translate(-50%,-50%)", animation:`${i%2===0?"spin":"spinR"} ${60+i*15}s linear infinite`,pointerEvents:"none" }}/>
            ))}
            <ParticleField count={24}/>
            <NoiseOverlay opacity={0.03}/>
            <div style={{ position:"absolute",left:0,right:0,height:2, background:"linear-gradient(90deg,transparent,rgba(212,148,10,.15),transparent)", animation:"scanline 8s linear infinite",pointerEvents:"none" }}/>

            <div style={{ maxWidth:1300,margin:"0 auto",padding:"8rem 3rem 5rem", display:"grid",gridTemplateColumns:"1fr 1fr",gap:"4rem",alignItems:"center",width:"100%",position:"relative",zIndex:2 }}>
                {/!* LEFT *!/}
                <div>
                    <div className="revealL" style={{ marginBottom:"2rem" }}>
                        <div style={{ display:"inline-flex",alignItems:"center",gap:".7rem", background:"rgba(180,130,30,.07)",border:`1px solid rgba(180,130,30,.22)`,borderRadius:4,padding:".4rem 1.1rem" }}>
                            <div style={{ width:5,height:5,background:GOLD,borderRadius:"50%",animation:"pulse2 2s ease-in-out infinite" }}/>
                            <span style={{ fontFamily:"'DM Mono',monospace",fontSize:".6rem",letterSpacing:".2em",color:GOLD }}>EST. FARM DIRECT SUPPLY</span>
                        </div>
                    </div>
                    <div className="revealL" style={{ transitionDelay:".1s",marginBottom:"1.6rem" }}>
                        <h1 style={{ fontFamily:"'Cormorant',serif",fontWeight:700,fontSize:"clamp(3.5rem,6.5vw,5.8rem)",color:CREAM,lineHeight:.98,letterSpacing:"-.02em" }}>
                            Premium<br/>
                            <em style={{ fontStyle:"italic",fontWeight:300, background:`linear-gradient(90deg,${AMBER},${GOLD},${GOLDB},${GOLDP},${GOLD})`, backgroundSize:"300%", WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent", animation:"gradShift 5s ease infinite" }}>Pork &amp;</em><br/>
                            <span style={{ color:CREAM }}>Livestock</span>
                        </h1>
                    </div>
                    <div className="revealL" style={{ transitionDelay:".15s" }}>
                        <div style={{ display:"flex",alignItems:"center",gap:"1rem",marginBottom:"1.75rem" }}>
                            <div style={{ width:60,height:1,background:`linear-gradient(90deg,${GOLD},transparent)` }}/>
                            <span style={{ fontFamily:"'DM Mono',monospace",fontSize:".6rem",color:MUTED,letterSpacing:".15em" }}>SINCE FARM DAY ONE</span>
                        </div>
                    </div>
                    <p className="revealL" style={{ transitionDelay:".2s", fontSize:"1rem",color:MUTED,maxWidth:420,lineHeight:1.9, fontFamily:"'DM Sans',sans-serif",fontWeight:300,marginBottom:"2.5rem" }}>{C.tagline} Bringing the highest standards in livestock quality and fresh pork directly to your table, every single day.</p>
                    <div className="revealL" style={{ transitionDelay:".28s",display:"flex",gap:"1rem",flexWrap:"wrap",marginBottom:"3.5rem" }}>
                        <a href={waLink} target="_blank" rel="noreferrer" className="shimmer-btn" style={{ display:"inline-flex",alignItems:"center",gap:".65rem", background:`linear-gradient(135deg,${WA},${GREEND})`, color:"#fff",padding:"1rem 2.2rem",borderRadius:6, fontWeight:700,fontSize:".92rem",textDecoration:"none",fontFamily:"'DM Sans',sans-serif", boxShadow:"0 8px 36px rgba(37,211,102,.35)" }}>
                            <span style={{ fontSize:18 }}>💬</span> Order on WhatsApp
                        </a>
                        <a href="#products" style={{ display:"inline-flex",alignItems:"center",gap:".55rem", border:`1px solid ${BORDER}`,color:CREAM, padding:"1rem 2.2rem",borderRadius:6,fontWeight:500,fontSize:".92rem",textDecoration:"none", fontFamily:"'DM Sans',sans-serif",background:"rgba(255,255,255,.025)" }}>Explore Products <span style={{ color:GOLD }}>→</span></a>
                    </div>
                    <div className="revealL" style={{ transitionDelay:".35s",display:"flex",gap:0 }}>
                        {[["5+","Product Types"],["100%","Farm Fresh"],["0","Middlemen"]].map(([n,l],i,arr) => (
                            <div key={l} style={{ padding:"1rem 1.75rem",textAlign:"center", borderRight:i<arr.length-1?`1px solid ${BORDER}`:"none", borderLeft:i===0?`1px solid ${BORDER}`:"none" }}>
                                <div style={{ fontFamily:"'Cormorant',serif",fontSize:"1.9rem",fontWeight:700,color:GOLDB,lineHeight:1 }}>{n}</div>
                                <div style={{ fontSize:".65rem",color:MUTED,marginTop:5,fontFamily:"'DM Sans',sans-serif",letterSpacing:".1em",textTransform:"uppercase" }}>{l}</div>
                            </div>
                        ))}
                    </div>
                </div>

                {/!* RIGHT *!/}
                <div className="revealR" style={{ transitionDelay:".15s",position:"relative" }}>
                    <div style={{ position:"relative",borderRadius:16,border:`1px solid ${BORDER}`,background:"linear-gradient(145deg,#120C05,#0A0704)",padding:"2.5rem",overflow:"hidden" }}>
                        {[["top","left"],["top","right"],["bottom","left"],["bottom","right"]].map(([v,h],i) => (
                            <div key={i} style={{ position:"absolute",[v]:0,[h]:0,width:40,height:40, borderTop:v==="top"?`2px solid ${GOLD}`:"none", borderBottom:v==="bottom"?`2px solid ${GOLD}`:"none", borderLeft:h==="left"?`2px solid ${GOLD}`:"none", borderRight:h==="right"?`2px solid ${GOLD}`:"none" }}/>
                        ))}
                        <div style={{ textAlign:"center",position:"relative" }}>
                            <div style={{ fontSize:110,marginBottom:"1rem",filter:"drop-shadow(0 20px 60px rgba(180,120,20,.3))",animation:"floatY 5s ease-in-out infinite" }}>🐷</div>
                            <div style={{ fontFamily:"'Cormorant',serif",fontSize:"3.5rem",fontWeight:300,color:CREAM,lineHeight:1,marginBottom:".5rem" }}>
                                ₹220<span style={{ fontSize:"1.2rem",color:MUTED,fontWeight:300 }}>/kg</span>
                            </div>
                            <div style={{ fontSize:".65rem",color:MUTED,fontFamily:"'DM Mono',monospace",letterSpacing:".18em",marginBottom:"1.5rem" }}>LIVE WEIGHT PRICE TODAY</div>
                            <Divider/>
                            <div style={{ display:"flex",flexDirection:"column",gap:".6rem",marginTop:"1rem" }}>
                                {[
                                    { label:"Quality Breeds",   icon:"🐷", price:"Market Rate" },
                                    { label:"Fresh Pork Meat",  icon:"🥩", price:"₹500/kg", hot:true },
                                    { label:"Frozen Pork Cuts", icon:"❄️", price:"₹550/kg" },
                                ].map(item => (
                                    <div key={item.label} style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:".65rem 1rem", background:item.hot?"rgba(180,130,30,.1)":"rgba(255,255,255,.025)", border:`1px solid ${item.hot?"rgba(180,130,30,.3)":"rgba(255,255,255,.05)"}`,borderRadius:8 }}>
                                        <div style={{ display:"flex",alignItems:"center",gap:".65rem" }}>
                                            <span style={{ fontSize:16 }}>{item.icon}</span>
                                            <span style={{ fontFamily:"'DM Sans',sans-serif",fontSize:".8rem",color:CREAM,fontWeight:400 }}>{item.label}</span>
                                        </div>
                                        <div style={{ display:"flex",alignItems:"center",gap:".5rem" }}>
                                            {item.hot && <span style={{ fontSize:".52rem",background:GOLD,color:"#000",padding:"2px 7px",borderRadius:3,fontWeight:700,letterSpacing:".1em" }}>HOT</span>}
                                            <span style={{ fontFamily:"'DM Mono',monospace",fontSize:".78rem",color:item.hot?GOLDB:MUTED }}>{item.price}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div style={{ position:"absolute",bottom:-60,left:"50%",transform:"translateX(-50%)",width:300,height:200,borderRadius:"50%",background:"radial-gradient(circle,rgba(180,120,20,.12) 0%,transparent 65%)",pointerEvents:"none" }}/>
                    </div>
                    <div style={{ position:"absolute",top:-18,right:-18, background:`linear-gradient(135deg,${AMBER},${GOLD})`,borderRadius:12,padding:"1rem 1.4rem", boxShadow:"0 20px 50px rgba(180,120,20,.4)",animation:"floatY 4s ease-in-out .5s infinite" }}>
                        <div style={{ fontFamily:"'Cormorant',serif",fontSize:"2rem",fontWeight:700,color:"#fff",lineHeight:1 }}>Daily</div>
                        <div style={{ fontSize:".6rem",color:"rgba(255,255,255,.8)",fontFamily:"'DM Sans',sans-serif",letterSpacing:".1em" }}>FRESH STOCK</div>
                    </div>
                    <div style={{ position:"absolute",bottom:-16,left:-16, background:CARD2,border:`1px solid ${BRHOT}`,borderRadius:12,padding:".9rem 1.2rem", display:"flex",alignItems:"center",gap:".75rem", boxShadow:"0 16px 48px rgba(0,0,0,.5)",animation:"floatY 4s ease-in-out 1.2s infinite" }}>
                        <div style={{ fontSize:28 }}>✅</div>
                        <div>
                            <div style={{ fontFamily:"'DM Sans',sans-serif",fontSize:".78rem",color:CREAM,fontWeight:600 }}>Health Certified</div>
                            <div style={{ fontSize:".6rem",color:MUTED,fontFamily:"'DM Mono',monospace" }}>ALL LIVESTOCK VETTED</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ position:"absolute",bottom:32,left:"50%",transform:"translateX(-50%)",display:"flex",flexDirection:"column",alignItems:"center",gap:".5rem",opacity:.5 }}>
                <div style={{ fontFamily:"'DM Mono',monospace",fontSize:".55rem",letterSpacing:".2em",color:MUTED }}>SCROLL</div>
                <div style={{ width:1,height:48,background:`linear-gradient(${GOLD},transparent)`,animation:"pulse2 2s ease-in-out infinite" }}/>
            </div>
        </section>
    );
}

/!* ── TICKER ── *!/
function Ticker() {
    const items = ["🐷 Quality Breeds","🐗 Prime Boars","🐽 Healthy Piglets","🥩 Fresh Pork Meat","❄️ Frozen Pork Cuts","⚖️ Live Weight Sales","🏆 Farm Direct","✅ Health Certified"];
    const rep = [...items,...items,...items];
    return (
        <div style={{ overflow:"hidden",borderTop:`1px solid ${BORDER}`,borderBottom:`1px solid ${BORDER}`,background:"rgba(180,130,30,.03)",padding:".7rem 0",position:"relative" }}>
            <div style={{ display:"flex",width:"max-content",animation:"marquee 30s linear infinite" }}>
                {rep.map((t,i) => (
                    <span key={i} style={{ whiteSpace:"nowrap",padding:"0 3rem",fontSize:".68rem",color:MUTED,fontFamily:"'DM Mono',monospace",letterSpacing:".12em" }}>
            <span style={{ color:GOLD,marginRight:".6rem" }}>◆</span>{t}
          </span>
                ))}
            </div>
        </div>
    );
}

/!* ── PRODUCTS ── *!/
const PRODS = [
    { name:"Quality Breeds",  tag:"LIVE STOCK",  icon:"🐷", desc:"Hand-selected premium pig breeds with exceptional genetics, robust health scores, and proven productivity records.", col:"#A0522D", num:"01" },
    { name:"Boars",           tag:"LIVE STOCK",  icon:"🐗", desc:"Virile, well-conditioned boars with superior bloodlines — ideal for breeding programs demanding the best.",         col:"#8B4513", num:"02" },
    { name:"Piglets",         tag:"LIVE STOCK",  icon:"🐽", desc:"Healthy, well-nourished weaners from top-quality parent stock, ready to thrive and grow on your farm.",            col:"#CD853F", num:"03" },
    { name:"Fresh Pork Meat", tag:"FRESH DAILY", icon:"🥩", desc:"Farm-to-table freshness. Processed every morning. Zero compromise on hygiene or quality.",                          col:"#C0392B", num:"04", price:"₹500/kg" },
    { name:"Frozen Pork Meat",tag:"FROZEN CUTS", icon:"❄️", desc:"Blast-frozen premium cuts, vacuum-sealed to lock in flavour. Consistent excellence every time.",                   col:"#2980B9", num:"05", price:"₹550/kg" },
];

function Products() {
    return (
        <section id="products" style={{ padding:"8rem 2rem",background:BG,position:"relative",overflow:"hidden" }}>
            <NoiseOverlay opacity={0.022}/>
            <div style={{ maxWidth:1260,margin:"0 auto",position:"relative",zIndex:1 }}>
                <div style={{ display:"grid",gridTemplateColumns:"1fr 2fr",gap:"3rem",alignItems:"end",marginBottom:"5rem" }}>
                    <div className="revealL">
                        <SectionLabel>What We Offer</SectionLabel>
                        <h2 style={{ fontFamily:"'Cormorant',serif",fontSize:"clamp(3rem,6vw,5rem)",fontWeight:700,color:CREAM,lineHeight:.92,letterSpacing:"-.02em" }}>
                            Our<br/><em style={{ fontStyle:"italic",fontWeight:300,color:GOLD }}>Products</em>
                        </h2>
                    </div>
                    <div className="revealR" style={{ paddingBottom:".5rem" }}>
                        <p style={{ fontFamily:"'DM Sans',sans-serif",fontWeight:300,fontSize:".95rem",color:MUTED,lineHeight:1.85,maxWidth:520 }}>
                            From prized live livestock to perfectly processed pork cuts — every product is a testament to our commitment to quality, hygiene, and direct farm freshness.
                        </p>
                    </div>
                </div>

                <div style={{ display:"grid",gridTemplateColumns:"repeat(12,1fr)",gap:"1.25rem" }}>
                    {/!* Large feature card *!/}
                    <TiltCard className="prod-card reveal" style={{ gridColumn:"span 5",gridRow:"span 2", background:`linear-gradient(145deg,${CARD},#0D0904)`, border:`1px solid ${BORDER}`,borderRadius:20,padding:"3rem 2.5rem",position:"relative",overflow:"hidden",transitionDelay:"0s" }}>
                        <div style={{ position:"absolute",top:0,left:0,right:0,height:3,background:`linear-gradient(90deg,transparent,${PRODS[3].col},transparent)` }}/>
                        <div style={{ position:"absolute",top:"1.5rem",right:"1.5rem",fontFamily:"'DM Mono',monospace",fontSize:".6rem",color:"rgba(180,130,30,.22)",letterSpacing:".1em" }}>{PRODS[3].num}</div>
                        <div style={{ fontSize:72,marginBottom:"1.5rem",filter:"drop-shadow(0 10px 30px rgba(192,57,43,.3))",animation:"floatY 5s ease-in-out infinite" }}>🥩</div>
                        <div style={{ fontSize:".58rem",letterSpacing:".25em",color:PRODS[3].col,fontWeight:700,fontFamily:"'DM Mono',monospace",marginBottom:".5rem" }}>{PRODS[3].tag}</div>
                        <h3 style={{ fontFamily:"'Cormorant',serif",fontSize:"2.2rem",color:CREAM,fontWeight:700,marginBottom:"1rem",lineHeight:1 }}>{PRODS[3].name}</h3>
                        <p style={{ fontSize:".83rem",color:MUTED,lineHeight:1.8,fontFamily:"'DM Sans',sans-serif",fontWeight:300 }}>{PRODS[3].desc}</p>
                        <div style={{ marginTop:"2rem",display:"flex",alignItems:"center",justifyContent:"space-between" }}>
                            <div style={{ background:"rgba(192,57,43,.1)",border:`1px solid rgba(192,57,43,.3)`,borderRadius:6,padding:".3rem .9rem",fontSize:".82rem",color:GOLDB,fontWeight:700,fontFamily:"'DM Mono',monospace" }}>{PRODS[3].price}</div>
                            <a href={waLink} target="_blank" rel="noreferrer" style={{ fontSize:".78rem",color:GREEN,fontFamily:"'DM Sans',sans-serif",textDecoration:"none",fontWeight:600 }}>Order →</a>
                        </div>
                        <div style={{ position:"absolute",bottom:-40,right:-40,width:180,height:180,borderRadius:"50%",background:`radial-gradient(circle,rgba(192,57,43,.08) 0%,transparent 70%)` }}/>
                    </TiltCard>

                    {[PRODS[0],PRODS[1],PRODS[2],PRODS[4]].map((p,i) => (
                        <TiltCard key={p.name} className="prod-card reveal" style={{ gridColumn:"span 4",transitionDelay:`${(i+1)*.1}s`, background:`linear-gradient(145deg,${CARD},#0D0904)`,border:`1px solid ${BORDER}`,borderRadius:16,padding:"2rem 1.75rem",position:"relative",overflow:"hidden" }}>
                            <div style={{ position:"absolute",top:0,left:0,right:0,height:2,background:`linear-gradient(90deg,transparent,${p.col},transparent)` }}/>
                            <div style={{ position:"absolute",top:"1rem",right:"1rem",fontFamily:"'DM Mono',monospace",fontSize:".58rem",color:"rgba(180,130,30,.2)" }}>{p.num}</div>
                            <div style={{ fontSize:44,marginBottom:"1.1rem" }}>{p.icon}</div>
                            <div style={{ fontSize:".56rem",letterSpacing:".22em",color:p.col,fontWeight:700,fontFamily:"'DM Mono',monospace",marginBottom:".4rem" }}>{p.tag}</div>
                            <h3 style={{ fontFamily:"'Cormorant',serif",fontSize:"1.5rem",color:CREAM,fontWeight:700,marginBottom:".7rem" }}>{p.name}</h3>
                            <p style={{ fontSize:".8rem",color:MUTED,lineHeight:1.75,fontFamily:"'DM Sans',sans-serif",fontWeight:300 }}>{p.desc}</p>
                            {p.price && <div style={{ marginTop:"1rem",fontSize:".78rem",color:GOLDB,fontFamily:"'DM Mono',monospace",fontWeight:500 }}>{p.price}</div>}
                            <div style={{ position:"absolute",bottom:-30,right:-30,width:100,height:100,borderRadius:"50%",background:`radial-gradient(circle,${p.col}10 0%,transparent 70%)` }}/>
                        </TiltCard>
                    ))}
                </div>
            </div>
        </section>
    );
}

/!* ── PRICING ── *!/
function Pricing() {
    const [active, setActive] = useState(1);
    const plans = [
        { icon:"⚖️",label:"Pork Live Weight",price:"₹220",unit:"/kg",note:"Sold on live weight basis",features:["Direct farm pricing","Live weight measured","Transparency guaranteed","Bulk discount available"] },
        { icon:"🥩",label:"Fresh Pork Meat",price:"₹500",unit:"/kg",note:"Freshly processed every morning",features:["Morning fresh processing","Hygienic packaging","Next-day guarantee","All cuts available"],hot:true },
        { icon:"❄️",label:"Frozen Pork Meat",price:"₹550",unit:"/kg",note:"Vacuum-packed, blast-frozen",features:["Blast frozen technology","Vacuum sealed packs","6 month shelf life","Bulk orders welcome"] },
    ];
    return (
        <section id="pricing" style={{ padding:"8rem 2rem",background:"#080604",position:"relative",overflow:"hidden" }}>
            <div style={{ position:"absolute",inset:0,background:"radial-gradient(ellipse 70% 50% at 50% 50%, rgba(120,70,10,.08) 0%, transparent 70%)" }}/>
            <NoiseOverlay opacity={0.025}/>
            <div style={{ maxWidth:1140,margin:"0 auto",position:"relative",zIndex:1 }}>
                <div className="reveal" style={{ textAlign:"center",marginBottom:"5rem" }}>
                    <SectionLabel>Transparent Pricing</SectionLabel>
                    <h2 style={{ fontFamily:"'Cormorant',serif",fontSize:"clamp(2.5rem,5.5vw,4.2rem)",color:CREAM,fontWeight:700,lineHeight:.95,letterSpacing:"-.02em" }}>Our Price List</h2>
                </div>
                <div className="reveal" style={{ display:"flex",justifyContent:"center",gap:".5rem",marginBottom:"3rem" }}>
                    {plans.map((p,i) => (
                        <button key={i} onClick={() => setActive(i)} style={{ background:active===i?`linear-gradient(135deg,${AMBER},${GOLD})`:"rgba(255,255,255,.04)", border:`1px solid ${active===i?GOLD:BORDER}`, color:active===i?"#fff":MUTED,padding:".5rem 1.4rem",borderRadius:100,cursor:"pointer", fontFamily:"'DM Sans',sans-serif",fontSize:".78rem",fontWeight:600,transition:"all .25s" }}>{p.label}</button>
                    ))}
                </div>
                <div className="reveal" style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:"1.5rem",marginBottom:"3rem" }}>
                    {plans.map((c,i) => (
                        <div key={c.label} className="price-wrap" style={{ background:c.hot?"linear-gradient(145deg,#1A1006,#251808)":CARD, border:`1px solid ${active===i?BRHOT:BORDER}`,borderRadius:20,padding:"2.5rem 2rem",textAlign:"center",position:"relative",overflow:"hidden", transform:active===i?"scale(1.03)":"scale(.98)",transition:"all .45s cubic-bezier(.16,1,.3,1)", boxShadow:active===i?"0 30px 70px rgba(0,0,0,.5)":"none" }}>
                            {c.hot && active===i && <div style={{ position:"absolute",top:-13,left:"50%",transform:"translateX(-50%)", background:`linear-gradient(135deg,${AMBER},${GOLD})`,color:"#fff",fontSize:".56rem",fontWeight:700,letterSpacing:".2em",padding:"5px 18px",borderRadius:100,whiteSpace:"nowrap" }}>★ BEST SELLER</div>}
                            <div style={{ fontSize:38,marginBottom:"1rem" }}>{c.icon}</div>
                            <div style={{ fontSize:".62rem",color:MUTED,fontFamily:"'DM Mono',monospace",marginBottom:".6rem",letterSpacing:".1em" }}>{c.label}</div>
                            <div style={{ display:"flex",alignItems:"baseline",justifyContent:"center",gap:5,marginBottom:".5rem" }}>
                                <span style={{ fontFamily:"'Cormorant',serif",fontSize:"3.4rem",fontWeight:700,color:active===i?GOLDB:CREAM,lineHeight:1 }}>{c.price}</span>
                                <span style={{ color:MUTED,fontSize:".9rem",fontFamily:"'DM Mono',monospace" }}>{c.unit}</span>
                            </div>
                            <div style={{ fontSize:".74rem",color:MUTED,fontFamily:"'DM Sans',sans-serif",fontWeight:300,marginBottom:"1.5rem" }}>{c.note}</div>
                            <div style={{ display:"flex",flexDirection:"column",gap:".5rem",marginBottom:"1.75rem" }}>
                                {c.features.map(f => (
                                    <div key={f} style={{ display:"flex",alignItems:"center",gap:".6rem",fontSize:".78rem",color:active===i?CREAM:MUTED,fontFamily:"'DM Sans',sans-serif" }}>
                                        <div style={{ width:16,height:16,borderRadius:"50%",background:active===i?"rgba(212,148,10,.15)":"rgba(255,255,255,.04)",border:`1px solid ${active===i?"rgba(212,148,10,.35)":BORDER}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:8,color:GOLD,flexShrink:0 }}>✓</div>
                                        {f}
                                    </div>
                                ))}
                            </div>
                            <a href={waLink} target="_blank" rel="noreferrer" style={{ display:"inline-block",background:active===i?`linear-gradient(135deg,${AMBER},${GOLD})`:"transparent",border:`1px solid ${active===i?GOLD:BORDER}`,color:active===i?"#fff":CREAM,padding:".65rem 1.8rem",borderRadius:6,fontSize:".8rem",fontWeight:600,textDecoration:"none",fontFamily:"'DM Sans',sans-serif",transition:"all .25s" }}>Order Now</a>
                        </div>
                    ))}
                </div>

                {/!* Breeders premium card *!/}
                <div className="reveal" style={{ position:"relative",background:"linear-gradient(135deg,#1A1006,#261608,#1A1006)",border:`1.5px solid rgba(212,148,10,.3)`,borderRadius:24,padding:"3.5rem",display:"grid",gridTemplateColumns:"1fr auto",gap:"3rem",alignItems:"center",overflow:"hidden" }}>
                    <div style={{ position:"absolute",top:0,left:0,right:0,height:2,background:`linear-gradient(90deg,transparent,${GOLD},${AMBER},${GOLDB},transparent)`,backgroundSize:"200%",animation:"borderFlow 3s linear infinite" }}/>
                    <div>
                        <div style={{ display:"flex",gap:".5rem",marginBottom:"1rem",flexWrap:"wrap" }}>
                            {["10 Quality Females","1 Prime Boar","Health Certified","Farm Direct"].map(t=>(
                                <span key={t} className="tag-pill" style={{ background:"rgba(212,148,10,.1)",border:`1px solid rgba(212,148,10,.25)`,color:GOLDB }}>
                  <span style={{ fontSize:8,color:GOLD }}>◆</span>{t}
                </span>
                            ))}
                        </div>
                        <div style={{ fontFamily:"'DM Mono',monospace",fontSize:".6rem",letterSpacing:".25em",color:GOLD,marginBottom:".75rem" }}>👑 PREMIUM BREEDING PACKAGE</div>
                        <h3 style={{ fontFamily:"'Cormorant',serif",fontSize:"2.8rem",color:CREAM,fontWeight:700,marginBottom:"1rem" }}>Breeders Unit</h3>
                        <p style={{ color:MUTED,fontSize:".88rem",lineHeight:1.85,fontFamily:"'DM Sans',sans-serif",fontWeight:300,maxWidth:500 }}>Complete breeding unit — <strong style={{ color:CREAM,fontWeight:500 }}>10 premium females + 1 prime boar</strong>. Genetically superior, health-certified, and farm-ready.</p>
                    </div>
                    <div style={{ textAlign:"center" }}>
                        <div style={{ fontSize:".65rem",color:MUTED,fontFamily:"'DM Mono',monospace",marginBottom:6 }}>1 UNIT · 11 ANIMALS</div>
                        <div style={{ fontFamily:"'Cormorant',serif",fontSize:"4rem",fontWeight:700,color:GOLD,lineHeight:1 }}>₹3,20,000</div>
                        <div style={{ fontSize:".68rem",color:MUTED,fontFamily:"'DM Mono',monospace",marginBottom:"1.5rem",marginTop:6 }}>PER COMPLETE UNIT</div>
                        <a href={waLink} target="_blank" rel="noreferrer" className="shimmer-btn" style={{ display:"inline-flex",alignItems:"center",gap:".6rem",background:`linear-gradient(135deg,${AMBER},${GOLD})`,color:"#fff",padding:".9rem 2.2rem",borderRadius:8,fontWeight:700,fontSize:".9rem",textDecoration:"none",fontFamily:"'DM Sans',sans-serif",boxShadow:`0 10px 36px rgba(180,120,20,.4)` }}>💬 Enquire Now</a>
                    </div>
                    <div style={{ position:"absolute",top:-80,right:-80,width:400,height:400,borderRadius:"50%",background:"radial-gradient(circle,rgba(212,148,10,.05) 0%,transparent 65%)",pointerEvents:"none" }}/>
                </div>
            </div>
        </section>
    );
}

/!* ── WHY US ── *!/
function WhyUs() {
    const pts = [
        { icon:"🏡",t:"Direct Farm",  d:"No middlemen. Freshest stock at fairest prices — straight from source.",           num:"01" },
        { icon:"🔬",t:"Health Certified",d:"All livestock regularly vetted. Strict quality and hygiene every day.",          num:"02" },
        { icon:"⚡",t:"Daily Fresh Stock",d:"Pork processed fresh every morning. Never yesterday's meat from us.",           num:"03" },
        { icon:"💬",t:"Instant WhatsApp",d:"Order directly on WhatsApp. Fast response, quick confirmation.",                num:"04" },
    ];
    return (
        <section id="why-us" style={{ padding:"8rem 2rem",background:BG,position:"relative",overflow:"hidden" }}>
            <div style={{ position:"absolute",right:0,top:0,bottom:0,width:"40%",background:"radial-gradient(ellipse 80% 60% at 80% 50%, rgba(120,70,10,.06) 0%, transparent 70%)",pointerEvents:"none" }}/>
            <NoiseOverlay opacity={0.02}/>
            <div style={{ maxWidth:1260,margin:"0 auto",position:"relative",zIndex:1 }}>
                <div style={{ display:"grid",gridTemplateColumns:"300px 1fr",gap:"5rem",alignItems:"start" }}>
                    <div className="revealL" style={{ position:"sticky",top:"8rem" }}>
                        <SectionLabel>Why Choose Us</SectionLabel>
                        <h2 style={{ fontFamily:"'Cormorant',serif",fontSize:"3.5rem",fontWeight:700,color:CREAM,lineHeight:.92,letterSpacing:"-.02em",marginBottom:"1.5rem" }}>
                            The Farm<br/><em style={{ fontStyle:"italic",fontWeight:300,color:GOLD }}>Fresh</em><br/>Difference
                        </h2>
                        <p style={{ fontFamily:"'DM Sans',sans-serif",fontSize:".85rem",color:MUTED,lineHeight:1.85,fontWeight:300 }}>Four pillars that make us the most trusted pork supplier in the region.</p>
                        <Divider/>
                        <a href={waLink} target="_blank" rel="noreferrer" style={{ display:"inline-flex",alignItems:"center",gap:".55rem",background:`linear-gradient(135deg,${GREEN},${GREEND})`,color:"#fff",padding:".85rem 2rem",borderRadius:8,fontWeight:700,fontSize:".88rem",textDecoration:"none",fontFamily:"'DM Sans',sans-serif",marginTop:"1rem",boxShadow:"0 8px 32px rgba(40,176,96,.3)" }}>💬 Order Now</a>
                    </div>
                    <div style={{ display:"flex",flexDirection:"column",gap:"1.25rem" }}>
                        {pts.map((p,i) => (
                            <div key={p.t} className="revealR prod-card" style={{ transitionDelay:`${i*.12}s`,background:CARD,border:`1px solid ${BORDER}`,borderRadius:16,padding:"2.2rem 2.5rem",display:"grid",gridTemplateColumns:"auto 1fr",gap:"2rem",alignItems:"center",position:"relative",overflow:"hidden" }}>
                                <div style={{ fontFamily:"'Cormorant',serif",fontSize:"5rem",fontWeight:700,color:"rgba(180,130,30,.1)",lineHeight:1,fontStyle:"italic" }}>{p.num}</div>
                                <div>
                                    <div style={{ display:"flex",alignItems:"center",gap:".75rem",marginBottom:".6rem" }}>
                                        <span style={{ fontSize:22 }}>{p.icon}</span>
                                        <h4 style={{ fontFamily:"'Cormorant',serif",fontSize:"1.6rem",color:CREAM,fontWeight:700 }}>{p.t}</h4>
                                    </div>
                                    <p style={{ fontSize:".83rem",color:MUTED,lineHeight:1.75,fontFamily:"'DM Sans',sans-serif",fontWeight:300 }}>{p.d}</p>
                                </div>
                                <div style={{ position:"absolute",left:0,top:0,bottom:0,width:2,background:`linear-gradient(${GOLD},transparent)`,opacity:.4 }}/>
                            </div>
                        ))}
                    </div>
                </div>

                {/!* Stats mosaic *!/}
                <div className="reveal" style={{ marginTop:"5rem",display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:"1px",background:BORDER,borderRadius:16,overflow:"hidden" }}>
                    {[[100,"%","Farm Fresh Quality"],[5,"+","Product Categories"],[365,"","Days Fresh Supply"],[0,"","Middlemen"]].map(([n,s,l],i) => (
                        <div key={l} style={{ background:i%2===0?CARD:CARD2,padding:"2.8rem 2rem",textAlign:"center",position:"relative",overflow:"hidden" }}>
                            <div style={{ fontFamily:"'Cormorant',serif",fontSize:"3.5rem",fontWeight:700,color:GOLDB,lineHeight:1 }}><CountUp end={n}/>{s}</div>
                            <div style={{ fontSize:".65rem",color:MUTED,fontFamily:"'DM Mono',monospace",marginTop:10,letterSpacing:".12em",textTransform:"uppercase" }}>{l}</div>
                            <div style={{ position:"absolute",bottom:0,left:"50%",transform:"translateX(-50%)",width:"60%",height:2,background:`linear-gradient(90deg,transparent,${GOLD},transparent)`,opacity:.3 }}/>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

/!* ── LOCATION ── *!/
function Location() {
    return (
        <section id="location" style={{ padding:"8rem 2rem",background:"#070503",position:"relative",overflow:"hidden" }}>
            <NoiseOverlay opacity={0.022}/>
            <div style={{ maxWidth:1100,margin:"0 auto",position:"relative",zIndex:1 }}>
                <div className="reveal" style={{ textAlign:"center",marginBottom:"4rem" }}>
                    <SectionLabel>Visit Us</SectionLabel>
                    <h2 style={{ fontFamily:"'Cormorant',serif",fontSize:"clamp(2.5rem,5.5vw,4rem)",color:CREAM,fontWeight:700,lineHeight:.95 }}>Find Our Farm & Shop</h2>
                    <p style={{ color:MUTED,fontSize:".88rem",fontFamily:"'DM Sans',sans-serif",marginTop:"1rem" }}>{C.address}</p>
                </div>
                <div style={{ display:"grid",gridTemplateColumns:"1fr 320px",gap:"1.5rem",alignItems:"stretch" }}>
                    <div className="revealL" style={{ borderRadius:20,overflow:"hidden",border:`1px solid ${BORDER}`,height:460,position:"relative" }}>
                        <iframe title="Map" src={C.mapsEmbed} width="100%" height="100%" style={{ border:0,display:"block",filter:"grayscale(30%) contrast(1.1) brightness(.8)" }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"/>
                        <div style={{ position:"absolute",inset:0,background:"linear-gradient(to bottom,transparent 60%,rgba(7,5,3,.8))",pointerEvents:"none" }}/>
                    </div>
                    <div className="revealR" style={{ display:"flex",flexDirection:"column",gap:"1rem" }}>
                        {[
                            { icon:"📍",label:"Address",val:C.address },
                            { icon:"📞",label:"Phone",val:C.phone,href:`tel:${C.phone}` },
                            { icon:"🕐",label:"Hours",val:C.hours },
                        ].map(x => (
                            <div key={x.label} style={{ background:CARD,border:`1px solid ${BORDER}`,borderRadius:16,padding:"1.5rem",position:"relative",overflow:"hidden" }}>
                                <div style={{ display:"flex",gap:".75rem" }}>
                                    <span style={{ fontSize:22 }}>{x.icon}</span>
                                    <div>
                                        <div style={{ fontSize:".58rem",letterSpacing:".2em",color:GOLD,fontFamily:"'DM Mono',monospace",marginBottom:".4rem" }}>{x.label.toUpperCase()}</div>
                                        {x.href
                                            ? <a href={x.href} style={{ color:CREAM,fontSize:".82rem",textDecoration:"none",lineHeight:1.65,fontFamily:"'DM Sans',sans-serif" }}>{x.val}</a>
                                            : <div style={{ color:CREAM,fontSize:".82rem",lineHeight:1.65,fontFamily:"'DM Sans',sans-serif" }}>{x.val}</div>
                                        }
                                    </div>
                                </div>
                                <div style={{ position:"absolute",right:0,top:0,bottom:0,width:2,background:`linear-gradient(${BORDER},transparent)` }}/>
                            </div>
                        ))}
                        <a href={C.mapsLink} target="_blank" rel="noreferrer" style={{ display:"flex",alignItems:"center",justifyContent:"center",gap:".6rem",background:`linear-gradient(135deg,${AMBER},${GOLD})`,color:"#fff",padding:"1rem",borderRadius:16,fontSize:".84rem",fontWeight:700,textDecoration:"none",fontFamily:"'DM Sans',sans-serif",boxShadow:"0 10px 32px rgba(180,120,20,.3)",flex:1 }}>📍 Open in Google Maps</a>
                    </div>
                </div>
            </div>
        </section>
    );
}

/!* ── CONTACT ── *!/
function Contact() {
    return (
        <section id="contact" style={{ padding:"8rem 2rem",background:BG,position:"relative",overflow:"hidden" }}>
            <ParticleField count={18}/>
            <NoiseOverlay opacity={0.03}/>
            <div style={{ position:"absolute",inset:0,background:"radial-gradient(ellipse 60% 50% at 50% 50%, rgba(100,55,8,.1) 0%, transparent 65%)" }}/>
            <div style={{ maxWidth:900,margin:"0 auto",textAlign:"center",position:"relative",zIndex:1 }}>
                <div className="reveal">
                    <SectionLabel>Get In Touch</SectionLabel>
                    <h2 style={{ fontFamily:"'Cormorant',serif",fontSize:"clamp(2.8rem,6vw,5rem)",color:CREAM,fontWeight:700,lineHeight:.9,letterSpacing:"-.02em",marginBottom:"1.25rem" }}>
                        Ready to Order<br/><em style={{ fontStyle:"italic",fontWeight:300,color:GOLD }}>Farm Fresh?</em>
                    </h2>
                    <p style={{ color:MUTED,fontSize:".92rem",lineHeight:1.9,fontFamily:"'DM Sans',sans-serif",fontWeight:300,maxWidth:480,margin:"0 auto 3rem" }}>
                        Tap the button below and chat with us directly. We confirm orders quickly and arrange delivery or pickup to suit your schedule.
                    </p>
                </div>
                <div className="reveal" style={{ background:"linear-gradient(135deg,rgba(37,211,102,.07),rgba(23,128,64,.03))",border:"1px solid rgba(37,211,102,.2)",borderRadius:28,padding:"4rem 3rem",position:"relative",overflow:"hidden",marginBottom:"3rem" }}>
                    <div style={{ position:"absolute",top:-80,right:-80,width:360,height:360,borderRadius:"50%",background:"radial-gradient(circle,rgba(37,211,102,.06) 0%,transparent 65%)" }}/>
                    <div style={{ position:"absolute",bottom:-80,left:-80,width:260,height:260,borderRadius:"50%",background:"radial-gradient(circle,rgba(37,211,102,.04) 0%,transparent 65%)" }}/>
                    <div style={{ position:"absolute",top:0,left:0,right:0,height:1,background:"linear-gradient(90deg,transparent,rgba(37,211,102,.4),transparent)" }}/>
                    <div style={{ fontSize:64,marginBottom:"1.25rem" }}>💬</div>
                    <h3 style={{ fontFamily:"'Cormorant',serif",fontSize:"2.6rem",color:CREAM,fontWeight:700,marginBottom:"1rem" }}>Chat on WhatsApp</h3>
                    <p style={{ color:MUTED,fontSize:".88rem",fontFamily:"'DM Sans',sans-serif",fontWeight:300,marginBottom:"2.5rem",maxWidth:420,margin:"0 auto 2.5rem" }}>We typically reply within minutes and confirm orders same day.</p>
                    <a href={waLink} target="_blank" rel="noreferrer" className="shimmer-btn" style={{ display:"inline-flex",alignItems:"center",gap:".8rem",background:`linear-gradient(135deg,${WA},${GREEND})`,color:"#fff",padding:"1.2rem 3rem",borderRadius:10,fontWeight:700,fontSize:"1.05rem",textDecoration:"none",fontFamily:"'DM Sans',sans-serif",boxShadow:"0 12px 48px rgba(37,211,102,.4)",animation:"waRing 2.5s ease-in-out infinite" }}>
                        <span style={{ fontSize:24 }}>💬</span> Chat with Us on WhatsApp
                    </a>
                    <div style={{ fontSize:".7rem",color:MUTED,fontFamily:"'DM Mono',monospace",marginTop:"1.25rem",letterSpacing:".1em" }}>FAST RESPONSE · GUARANTEED FRESHNESS</div>
                </div>
                <div className="reveal" style={{ display:"flex",gap:"1px",background:BORDER,borderRadius:16,overflow:"hidden" }}>
                    {[{ icon:"📞",l:"Phone",v:C.phone,href:`tel:${C.phone}` },{ icon:"📍",l:"Location",v:C.address },{ icon:"🕐",l:"Hours",v:"Mon–Sat 6AM–8PM" }].map((x,i) => (
                        <div key={i} style={{ flex:1,background:i%2===0?CARD:CARD2,padding:"1.75rem 1.5rem",textAlign:"center" }}>
                            <div style={{ fontSize:26,marginBottom:".6rem" }}>{x.icon}</div>
                            <div style={{ fontSize:".58rem",color:GOLD,fontFamily:"'DM Mono',monospace",letterSpacing:".2em",marginBottom:".4rem" }}>{x.l.toUpperCase()}</div>
                            {x.href
                                ? <a href={x.href} style={{ fontSize:".8rem",color:CREAM,textDecoration:"none",fontFamily:"'DM Sans',sans-serif" }}>{x.v}</a>
                                : <div style={{ fontSize:".8rem",color:CREAM,fontFamily:"'DM Sans',sans-serif",lineHeight:1.6 }}>{x.v}</div>
                            }
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

/!* ── FOOTER ── *!/
function Footer() {
    return (
        <footer style={{ background:"#030201",borderTop:`1px solid ${BORDER}`,padding:"4rem 2rem 2rem" }}>
            <div style={{ maxWidth:1260,margin:"0 auto" }}>
                <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:"2rem",marginBottom:"3rem" }}>
                    <div>
                        <div style={{ display:"flex",alignItems:"center",gap:".75rem",marginBottom:"1.25rem" }}>
                            <div style={{ width:40,height:40,border:`1.5px solid ${AMBER}`,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18 }}>🐷</div>
                            <div>
                                <div style={{ fontFamily:"'Cormorant',serif",fontWeight:700,fontSize:"1rem",color:GOLD }}>{C.name}</div>
                                <div style={{ fontSize:".5rem",color:MUTED,fontFamily:"'DM Mono',monospace",letterSpacing:".15em" }}>PREMIUM LIVESTOCK</div>
                            </div>
                        </div>
                        <p style={{ color:MUTED,fontSize:".78rem",fontFamily:"'DM Sans',sans-serif",fontWeight:300,lineHeight:1.8 }}>{C.tagline}</p>
                    </div>
                    <div>
                        <div style={{ fontSize:".58rem",letterSpacing:".22em",color:GOLD,fontWeight:700,fontFamily:"'DM Mono',monospace",marginBottom:"1.2rem" }}>PRODUCTS</div>
                        {["Quality Breeds","Boars","Piglets","Fresh Pork Meat","Frozen Pork Meat"].map(item => (
                            <div key={item} style={{ fontSize:".78rem",color:MUTED,fontFamily:"'DM Sans',sans-serif",marginBottom:".5rem" }}>{item}</div>
                        ))}
                    </div>
                    <div>
                        <div style={{ fontSize:".58rem",letterSpacing:".22em",color:GOLD,fontWeight:700,fontFamily:"'DM Mono',monospace",marginBottom:"1.2rem" }}>CONTACT</div>
                        <div style={{ fontSize:".78rem",color:MUTED,fontFamily:"'DM Sans',sans-serif",marginBottom:".55rem" }}>{C.phone}</div>
                        <div style={{ fontSize:".78rem",color:MUTED,fontFamily:"'DM Sans',sans-serif",marginBottom:".55rem",lineHeight:1.6 }}>{C.address}</div>
                        <a href={waLink} target="_blank" rel="noreferrer" style={{ fontSize:".78rem",color:GREEN,textDecoration:"none",fontFamily:"'DM Sans',sans-serif",fontWeight:600 }}>💬 WhatsApp Us</a>
                    </div>
                    <div>
                        <div style={{ fontSize:".58rem",letterSpacing:".22em",color:GOLD,fontWeight:700,fontFamily:"'DM Mono',monospace",marginBottom:"1.2rem" }}>HOURS</div>
                        <div style={{ fontSize:".78rem",color:MUTED,fontFamily:"'DM Sans',sans-serif",lineHeight:1.8 }}>{C.hours}</div>
                    </div>
                </div>
                <div style={{ borderTop:`1px solid ${BORDER}`,paddingTop:"1.5rem",display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:"1rem" }}>
                    <div style={{ fontSize:".68rem",color:"rgba(140,120,90,.25)",fontFamily:"'DM Mono',monospace" }}>© {new Date().getFullYear()} {C.name}. ALL RIGHTS RESERVED.</div>
                    <div style={{ fontSize:".68rem",color:"rgba(140,120,90,.25)",fontFamily:"'DM Mono',monospace" }}>PREMIUM PORK & LIVESTOCK · DIRECT FARM</div>
                </div>
            </div>
        </footer>
    );
}

function FloatWA() {
    const [show, setShow] = useState(false);
    useEffect(() => { const t = setTimeout(() => setShow(true), 2200); return () => clearTimeout(t); }, []);
    if (!show) return null;
    return (
        <a href={waLink} target="_blank" rel="noreferrer" title="Order on WhatsApp" style={{ position:"fixed",bottom:32,right:32,zIndex:9999,width:62,height:62,borderRadius:"50%",background:`linear-gradient(135deg,${WA},${GREEND})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:28,textDecoration:"none",boxShadow:"0 10px 40px rgba(37,211,102,.55)",animation:"waRing 2.5s ease-in-out infinite" }}>💬</a>
    );
}

export default function App() {
    useStyles();
    useReveal();
    return (
        <div style={{ background:BG, color:CREAM, minHeight:"100vh" }}>
            <CustomCursor/>
            <Navbar/>
            <Hero/>
            <Ticker/>
            <Products/>
            <Pricing/>
            <WhyUs/>
            <Location/>
            <Contact/>
            <Footer/>
            <FloatWA/>
        </div>
    );
}*/
